(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mayas-floating-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('floating-video')) return;

    var HIDE_KEY = 'mayas_fv_hidden';
    var SRC_KEY = 'mayas_fv_src_';
    var GUARDS = [
      '.shopify-section--mayas-v3-pdp-variants',
      '.shopify-section--mayas-v3-pdp-atc',
      '.shopify-section--mayas-v3-pdp-pads',
      '.shopify-section--mayas-v2-pdp-variants',
      '.shopify-section--mayas-v2-pdp-atc',
      '.shopify-section--mayas-v2-pdp-pads',
      '.product-info__variant-picker',
      '.product-info__buy-buttons'
    ].join(',');
    var STRIPS = '#mayas-v3-sticky-atc, #mayas-v2-sticky-atc';
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

    function session(fn) {
      try { return fn(window.sessionStorage); } catch (e) { return null; }
    }

    function resolveSources(src) {
      var m = /\/videos\/c\/(?:o\/v|vp\/[0-9a-f]{32})\/([0-9a-f]{32})/.exec(src || '');
      var plain = { pill: src, dialog: src };
      if (!m || !window.fetch) return Promise.resolve(plain);
      var hash = m[1];
      var base = 'https://cdn.shopify.com/videos/c/vp/' + hash + '/';
      var cached = session(function (s) { return s.getItem(SRC_KEY + hash); });
      if (cached) {
        try { return Promise.resolve(JSON.parse(cached)); } catch (e) { /* refetch */ }
      }
      return fetch(base + hash + '.m3u8')
        .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('m3u8')); })
        .then(function (txt) {
          var byHeight = {};
          txt.split('\n').forEach(function (line) {
            var v = /^[0-9a-f]{32}\.((?:SD|HD)-(\d+)p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/.exec(line.trim());
            if (v) byHeight[v[2]] = base + hash + '.' + v[1] + '-' + v[3] + '-' + v[4] + '.mp4';
          });
          var res = {
            pill: byHeight['480'] || byHeight['720'] || src,
            dialog: byHeight['720'] || byHeight['480'] || src
          };
          session(function (s) { s.setItem(SRC_KEY + hash, JSON.stringify(res)); });
          return res;
        })
        .catch(function () { return plain; });
    }

    class FloatingVideo extends HTMLElement {
      connectedCallback() {
        this.src = this.getAttribute('data-src');
        this.dock = this.querySelector('[data-fv-dock]');
        this.pill = this.querySelector('[data-fv-open]');
        this.pillVideo = this.querySelector('[data-fv-pill-video]');
        this.hideBtn = this.querySelector('[data-fv-hide]');
        this.dialog = this.querySelector('[data-fv-dialog]');
        this.dialogVideo = this.querySelector('[data-fv-dialog-video]');
        this.soundBtn = this.querySelector('[data-fv-sound]');
        this.progress = this.querySelector('[data-fv-progress]');
        this.form = this.querySelector('[data-fv-form]');
        this.sizeValue = this.querySelector('[data-fv-size-value]');
        this.note = this.querySelector('[data-fv-note]');
        this.priceEl = this.querySelector('[data-fv-price]');
        this.ctaLabel = this.querySelector('[data-fv-cta-label]');
        this.addBtn = this.querySelector('[data-fv-add]');
        this.errEl = this.querySelector('[data-fv-err]');
        if (!this.src || !this.dock || !this.pill || !this.dialog) return;

        this.ready = false;
        this.shown = false;
        this.dialogOpen = false;
        this.dismissed = session(function (s) { return s.getItem(HIDE_KEY); }) === '1';
        this.still = reduceMotion.matches || !!(navigator.connection && navigator.connection.saveData);
        if (this.dismissed) return;

        this.raf = 0;
        this.schedule = () => {
          if (!this.raf) this.raf = window.requestAnimationFrame(() => { this.raf = 0; this.update(); });
        };

        this.pill.addEventListener('click', () => this.open());
        this.hideBtn.addEventListener('click', () => this.dismiss());
        this.querySelectorAll('[data-fv-close]').forEach((el) => el.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); });
        this.dialog.addEventListener('close', () => this.onClose());
        this.dialogVideo.addEventListener('click', () => {
          if (this.dialogVideo.paused) this.play(this.dialogVideo); else this.dialogVideo.pause();
        });
        this.dialogVideo.addEventListener('timeupdate', () => {
          var d = this.dialogVideo.duration;
          if (this.progress && d) this.progress.style.transform = 'scaleX(' + (this.dialogVideo.currentTime / d) + ')';
        });
        this.soundBtn.addEventListener('click', () => this.setMuted(!this.dialogVideo.muted));
        this.querySelectorAll('[data-fv-size]').forEach((input) => input.addEventListener('change', () => this.select(input)));
        this.form.addEventListener('submit', (e) => this.addToCart(e));

        window.addEventListener('scroll', this.schedule, { passive: true });
        window.addEventListener('resize', () => { this.measure(); this.schedule(); });
        document.addEventListener('visibilitychange', this.schedule);

        this.measure();
        var checked = this.form.querySelector('[data-fv-size]:checked');
        if (checked) this.select(checked);

        var boot = () => {
          var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1200); };
          idle(() => this.boot(), { timeout: 3000 });
        };
        if (document.readyState === 'complete') boot();
        else window.addEventListener('load', boot, { once: true });
      }

      measure() {
        var strip = window.innerWidth < 768 ? document.querySelector(STRIPS) : null;
        var h = strip ? strip.offsetHeight : 0;
        if (h) this.style.setProperty('--fv-clear', h + 'px');
        else this.style.removeProperty('--fv-clear');
      }

      boot() {
        resolveSources(this.src).then((sources) => {
          this.sources = sources;
          var v = this.pillVideo;
          v.addEventListener('loadeddata', () => {
            this.ready = true;
            if (this.still) {
              var p = v.play();
              if (p && p.then) p.then(() => v.pause()).catch(() => {});
            }
            this.update();
          }, { once: true });
          v.preload = this.still ? 'metadata' : 'auto';
          v.src = this.still ? sources.pill + '#t=0.1' : sources.pill;
          v.load();
        });
      }

      overlaps() {
        var r = this.pill.getBoundingClientRect();
        var pad = 12;
        var guards = document.querySelectorAll(GUARDS);
        for (var i = 0; i < guards.length; i++) {
          var g = guards[i].getBoundingClientRect();
          if (!g.width || !g.height) continue;
          if (g.bottom > r.top - pad && g.top < r.bottom + pad && g.right > r.left - pad && g.left < r.right + pad) return true;
        }
        return false;
      }

      update() {
        var show = this.ready && !this.dismissed && !this.dialogOpen && !document.hidden && !this.overlaps();
        if (show !== this.shown) {
          this.shown = show;
          this.dock.classList.toggle('is-shown', show);
          this.dock.setAttribute('aria-hidden', show ? 'false' : 'true');
          this.dock.inert = !show;
        }
        if (!this.ready || this.still) return;
        if (show && this.pillVideo.paused) this.play(this.pillVideo);
        else if (!show && !this.pillVideo.paused) this.pillVideo.pause();
      }

      play(video) {
        var p = video.play();
        if (p && p.catch) p.catch(() => {});
        return p;
      }

      dismiss() {
        this.dismissed = true;
        session(function (s) { s.setItem(HIDE_KEY, '1'); });
        this.update();
        this.pillVideo.pause();
        this.pillVideo.removeAttribute('src');
        this.pillVideo.load();
      }

      setMuted(muted) {
        this.dialogVideo.muted = muted;
        this.soundBtn.setAttribute('aria-pressed', muted ? 'false' : 'true');
      }

      preselect() {
        if (this.form.querySelector('[data-fv-size]:checked')) return;
        var ids = [];
        try { ids.push(new URLSearchParams(window.location.search).get('variant')); } catch (e) { /* no URL API */ }
        var active = document.querySelector('.mayas-v3-size--active[data-variant-id], .mayas-v2-size--active[data-variant-id]');
        if (active) ids.push(active.getAttribute('data-variant-id'));
        for (var i = 0; i < ids.length; i++) {
          if (!ids[i]) continue;
          var input = this.form.querySelector('[data-fv-size][value="' + ids[i] + '"]');
          if (input && !input.disabled) { input.checked = true; this.select(input); return; }
        }
      }

      open() {
        this.dialogOpen = true;
        this.update();
        var src = this.sources ? this.sources.dialog : this.src;
        if (this.dialogVideo.getAttribute('src') !== src) {
          this.dialogVideo.preload = 'auto';
          this.dialogVideo.src = src;
        }
        this.preselect();
        if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        document.documentElement.classList.add('mayas-fv-lock');
        /* Always muted; sound only after an explicit tap on the speaker button. */
        this.setMuted(true);
        this.play(this.dialogVideo);
      }

      onClose() {
        this.dialogVideo.pause();
        document.documentElement.classList.remove('mayas-fv-lock');
        this.dialogOpen = false;
        this.update();
        if (this.shown) this.pill.focus({ preventScroll: true });
      }

      selected() {
        return this.form.querySelector('[data-fv-size]:checked') || this.form.querySelector('[data-fv-single]');
      }

      select(input) {
        var state = input.getAttribute('data-state');
        if (this.sizeValue) this.sizeValue.textContent = input.getAttribute('data-title') || '';
        if (this.priceEl) this.priceEl.textContent = input.getAttribute('data-price') || this.priceEl.textContent;
        if (this.ctaLabel) {
          this.ctaLabel.textContent = this.addBtn.getAttribute(state === 'preorder' ? 'data-label-preorder' : 'data-label-add');
        }
        if (this.note) {
          this.note.textContent = input.getAttribute('data-note') || '';
          this.note.setAttribute('data-state', state);
        }
        if (this.errEl) this.errEl.hidden = true;
      }

      async addToCart(e) {
        e.preventDefault();
        if (this.errEl) this.errEl.hidden = true;
        var input = this.selected();
        if (!input) {
          if (this.note) {
            this.note.textContent = this.addBtn.getAttribute('data-label-choose');
            this.note.setAttribute('data-state', 'prompt');
          }
          var first = this.form.querySelector('[data-fv-size]:not(:disabled)');
          if (first) first.focus();
          return;
        }
        var id = input.value;
        this.addBtn.setAttribute('aria-busy', 'true');
        /* Pads rule 2026-09-24: garment + its own metafield pads in one call via the shared
           window.themeAddToCart (pads pre-rendered above). The garment-only fetch below is
           the legacy path, kept as the fallback when the shared file is not loaded. */
        if (typeof window.themeAddToCart === 'function') {
          try {
            await window.themeAddToCart(id, { quantity: 1, source: 'floating_video', open: false });
            this.dialog.close();
            var fvDrawerToggle = document.querySelector('[aria-controls="cart-drawer"]');
            if (fvDrawerToggle) fvDrawerToggle.click();
          } catch (err) {
            if (this.errEl) this.errEl.hidden = false;
            window.location.href = '/cart';
          } finally {
            this.addBtn.removeAttribute('aria-busy');
          }
          return;
        }
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          });
          if (!res.ok) throw new Error('add failed');
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          var drawerToggle = document.querySelector('[aria-controls="cart-drawer"]');
          this.dialog.close();
          if (drawerToggle) drawerToggle.click();
          else window.location.href = '/cart';
        } catch (err) {
          if (this.errEl) this.errEl.hidden = false;
          window.location.href = '/cart';
        } finally {
          this.addBtn.removeAttribute('aria-busy');
        }
      }
    }

    customElements.define('floating-video', FloatingVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-atc"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Variant hidden input update - ATC form syncs to size selection
  ---------------------------------------------------------------- */
  function initAtcVariantSync() {
    var hiddenInput = document.getElementById('mayas-v2-variant-id');
    var btnLabel    = document.getElementById('mayas-v2-atc-btn-label');
    var btnPrice    = document.getElementById('mayas-v2-atc-btn-price');
    var atcBtn      = document.getElementById('mayas-v2-atc-btn');
    var stickySize  = document.getElementById('mayas-v2-sticky-size');
    var klarnaText  = document.getElementById('mayas-v2-klarna-text');

    document.addEventListener('mayas-v2:variant-change', function(e) {
      var detail  = e.detail || {};
      var variant = detail.variant || {};
      if (!variant.id) return;

      /* Update hidden form input */
      if (hiddenInput) hiddenInput.value = variant.id;

      /* Reflect stock state on ATC root so the delivery chip can hide on preorder */
      var atcRootEl2 = document.getElementById('mayas-v2-atc');
      if (atcRootEl2 && variant.state) {
        atcRootEl2.setAttribute('data-stock-state', variant.state);
      }

      /* Update button label based on variant state. Strings come from
         data-label-* attrs on the ATC root, populated by Liquid `| t`
         at render time. */
      if (atcBtn && btnLabel) {
        var atcRootEl = document.getElementById('mayas-v2-atc');
        var isPreorderProduct = atcRootEl ? atcRootEl.getAttribute('data-preorder') === 'true' : false;
        var labelOos      = atcRootEl ? (atcRootEl.getAttribute('data-label-sold-out')  || '') : '';
        var labelPreorder = atcRootEl ? (atcRootEl.getAttribute('data-label-pre-order') || '') : '';
        var labelAdd      = atcRootEl ? (atcRootEl.getAttribute('data-label-add')       || '') : '';

        if (variant.state === 'out') {
          btnLabel.textContent = labelOos;
          atcBtn.classList.add('mayas-v2-atc__btn--oos');
          atcBtn.setAttribute('aria-disabled', 'true');
        } else if (variant.state === 'preorder' || isPreorderProduct) {
          btnLabel.textContent = labelPreorder;
          atcBtn.classList.remove('mayas-v2-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        } else {
          btnLabel.textContent = labelAdd;
          atcBtn.classList.remove('mayas-v2-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        }
      }

      var atcRoot = document.getElementById('mayas-v2-atc');
      var shopLocale = atcRoot ? (atcRoot.getAttribute('data-shop-locale') || 'en') : 'en';
      var shopCurrency = atcRoot ? (atcRoot.getAttribute('data-shop-currency') || 'DKK') : 'DKK';

      /* Btn price prefers variant.price_formatted (Liquid-rendered, locale-correct).
         For derived numbers (Klarna quarter, bundle math) we have no Liquid equivalent,
         so we format via Intl.NumberFormat with shop-locale + shop-currency from the
         data-attrs above. Shopify.formatMoney is not used - see
         theme-knowledge/bugs/money-formatting-via-liquid.md. */
      function toFormatted(cents) {
        try {
          return new Intl.NumberFormat(shopLocale, {
            style: 'currency',
            currency: shopCurrency
          }).format(cents / 100);
        } catch (e) {
          return (cents / 100).toFixed(2) + ' ' + shopCurrency;
        }
      }

      /* Update button price */
      if (btnPrice) {
        if (variant.price_formatted) {
          btnPrice.textContent = variant.price_formatted;
        } else if (variant.price) {
          btnPrice.textContent = toFormatted(variant.price);
        }
      }

      /* Update Klarna line. Locale strings come from data-klarna-before / -after
         on the ATC root; only the price changes per variant. */
      if (klarnaText && variant.price) {
        var quarter = Math.round(variant.price / 4);
        var klarnaBefore = atcRoot ? (atcRoot.getAttribute('data-klarna-before') || '') : '';
        var klarnaAfter  = atcRoot ? (atcRoot.getAttribute('data-klarna-after')  || '') : '';
        klarnaText.innerHTML = klarnaBefore + '<b>' + toFormatted(quarter) + '</b>' + klarnaAfter;
      }

      /* Update sticky size label */
      if (stickySize && variant.title) {
        stickySize.textContent = variant.title;
      }
    });
  }

  /* ----------------------------------------------------------------
     Cart add - main variant + currently-selected pad, in one request
     Intercepts both the primary form submit and the sticky ATC click.
  ---------------------------------------------------------------- */
  function addToCart() {
    var form = document.getElementById('mayas-v2-product-form');
    if (!form) return Promise.reject(new Error('no-form'));

    var mainIdEl = document.getElementById('mayas-v2-variant-id');
    if (!mainIdEl || !mainIdEl.value) return Promise.reject(new Error('no-variant'));

    var items = [{ id: mainIdEl.value, quantity: 1 }];

    var pad = window.__mayasV2SelectedPad;
    if (pad && pad.variantId) {
      items.push({ id: pad.variantId, quantity: 1 });
    }

    /* BOGO free item (mayas-v2-pdp-bogo section, 2026-07-11): the native
       Buy X Get Y automatic discount zeroes the cheapest at checkout. */
    var bogo = window.__mayasV2SelectedBogo;
    if (bogo && bogo.variantId) {
      items.push({ id: bogo.variantId, quantity: 1 });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(e) { throw e; });
      return r.json();
    })
    .then(function(data) {
      /* Tell Prestige's cart system to refresh its drawer / notification */
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { source: 'mayas-v2-atc' }
      }));
      document.dispatchEvent(new CustomEvent('cart:added', {
        bubbles: true,
        detail: { items: items, response: data }
      }));

      /* Try to open the cart drawer; fall back to /cart page */
      var drawerTrigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
      return data;
    });
  }

  function initAtcSubmit() {
    var form = document.getElementById('mayas-v2-product-form');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = document.getElementById('mayas-v2-atc-btn');
      if (btn) btn.setAttribute('aria-busy', 'true');
      addToCart().catch(function(err) {
        console.error('[mayas-v2 ATC]', err);
        window.location.href = '/cart';
      }).then(function() {
        if (btn) btn.removeAttribute('aria-busy');
      });
    });
  }

  /* ----------------------------------------------------------------
     Sticky ATC - show after main ATC button scrolls above viewport
  ---------------------------------------------------------------- */
  function initStickyAtc() {
    var sticky  = document.getElementById('mayas-v2-sticky-atc');
    var trigger = document.getElementById('mayas-v2-atc-btn');
    if (!sticky || !trigger) return;

    var stickyBtn = document.getElementById('mayas-v2-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        stickyBtn.setAttribute('aria-busy', 'true');
        addToCart().catch(function(err) {
          console.error('[mayas-v2 sticky ATC]', err);
          window.location.href = '/cart';
        }).then(function() {
          stickyBtn.removeAttribute('aria-busy');
        });
      });
    }

    var io = new IntersectionObserver(
      function(entries) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) {
            sticky.classList.add('mayas-v2-sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('mayas-v2-sticky-atc--visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    io.observe(trigger);
  }

  /* ----------------------------------------------------------------
     Delivery ETA - countdown to daily cutoff + delivered-by date
     All times resolved in browser-local (visitor is DK for Phase 1).
  ---------------------------------------------------------------- */
  function initDeliveryEta() {
    var root = document.getElementById('mayas-v2-eta');
    if (!root) return;
    var cdEl   = document.getElementById('mayas-v2-eta-countdown');
    var dateEl = document.getElementById('mayas-v2-eta-date');
    if (!cdEl || !dateEl) return;

    var cutoffHour   = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 14;
    var businessDays = parseInt(root.getAttribute('data-business-days'), 10) || 3;
    var cdFormat     = root.getAttribute('data-countdown-format') || '{h}h {m}m';
    var locale       = root.getAttribute('data-locale') || 'da';
    var dateLocale   = locale.indexOf('da') === 0 ? 'da-DK' : 'en-GB';

    function isWeekend(d) {
      var day = d.getDay();
      return day === 0 || day === 6;
    }

    function addBusinessDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) {
        r.setDate(r.getDate() + 1);
        if (!isWeekend(r)) n--;
      }
      return r;
    }

    function nextBusinessDay(d) {
      var r = new Date(d.getTime());
      do { r.setDate(r.getDate() + 1); } while (isWeekend(r));
      return r;
    }

    function formatCountdown(ms) {
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      var h = Math.floor(totalMin / 60);
      var m = totalMin % 60;
      return cdFormat.replace('{h}', h).replace('{m}', m);
    }

    function formatDate(d) {
      try {
        return d.toLocaleDateString(dateLocale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long'
        });
      } catch (e) {
        return d.toISOString().slice(0, 10);
      }
    }

    function update() {
      var now = new Date();
      var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
      var beforeCutoffWeekday = !isWeekend(now) && (now < todayCutoff);

      var dispatch, cutoff;
      if (beforeCutoffWeekday) {
        dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        cutoff   = todayCutoff;
      } else {
        dispatch = nextBusinessDay(now);
        cutoff   = new Date(dispatch.getFullYear(), dispatch.getMonth(), dispatch.getDate(), cutoffHour, 0, 0, 0);
      }

      var delivery = addBusinessDays(dispatch, businessDays);
      cdEl.textContent   = formatCountdown(cutoff.getTime() - now.getTime());
      dateEl.textContent = formatDate(delivery);
    }

    update();
    /* Refresh every minute so countdown stays live. */
    setInterval(update, 60 * 1000);
  }

  /* Fit-finder CTA opens Wair - polls for the Wair-injected button
     (rendered in section mayas-v2-pdp-wair below). 10s deadline matches snippets/wair.liquid. */
  function initFitFinderCta() {
    var ffBtn = document.getElementById('mayas-v2-fit-finder-cta');
    if (!ffBtn) return;
    ffBtn.addEventListener('click', function() {
      /* Same Wair-unavailable fallback as the variants find-size chip:
         poll 4s for the Wair-injected button, then open the size-guide
         page rather than doing nothing (Wair origin-gates theme-dev and
         its load endpoint can 400 on live). */
      var deadline = Date.now() + 4000;
      (function tryOpen() {
        var w = document.getElementById('wair-fit-advisor');
        if (w) { w.click(); return; }
        if (Date.now() < deadline) { window.requestAnimationFrame(tryOpen); return; }
        var g = document.querySelector('.mayas-v2-variants__guide-link');
        if (g && g.getAttribute('href') && g.getAttribute('href') !== '#') window.location.href = g.href;
      })();
    });
  }

  /* Contribe badge_embed pill viewport-aware relocation.
     The badge_placement_selector ('.mayas-v2-atc__apps, .product-info .buy-buttons')
     resolves via document-order first-match. Prestige's .buy-buttons is earlier in
     DOM than .mayas-v2-atc__apps, so Contribe injects there. On mobile the Prestige
     main-product is hidden by the viewport gate (see mayas-v2-pdp-hero.liquid),
     so the pill renders inside a display:none ancestor and is invisible. Since
     2026-07-06 Prestige is hidden at every width, so the pill is always moved
     into .mayas-v2-atc__apps (the visible v2 slot). */
  function initContribePillRelocator() {
    var slot = document.querySelector('.mayas-v2-atc__apps');
    if (!slot) return;
    /* 2026-07-06: Prestige main-product is now hidden at ALL widths (v2 is the
       single PDP), so the pill's first-match target is always inside a
       display:none ancestor — relocate on every viewport, not just mobile. */

    function tryMove() {
      var badge = document.querySelector('[id^="contribe_badge_"]');
      if (!badge) return false;
      if (slot.contains(badge)) return true;
      slot.appendChild(badge);
      return true;
    }

    if (tryMove()) return;

    var observer = new MutationObserver(function() {
      if (tryMove()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(function() { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAtcVariantSync();
      initAtcSubmit();
      initStickyAtc();
      initDeliveryEta();
      initFitFinderCta();
      initContribePillRelocator();
    });
  } else {
    initAtcVariantSync();
    initAtcSubmit();
    initStickyAtc();
    initDeliveryEta();
    initFitFinderCta();
    initContribePillRelocator();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-bogo"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.querySelector('[data-bogo]');
  if (!root) return;

  var toggle = root.querySelector('#mayas-v2-bogo-toggle');
  var body = root.querySelector('#mayas-v2-bogo-body');
  var status = root.querySelector('#mayas-v2-bogo-status');
  var rows = Array.prototype.slice.call(root.querySelectorAll('[data-bogo-row]'));
  var defaultStatus = status ? status.textContent : '';

  function clearSelection() {
    window.__mayasV2SelectedBogo = null;
    rows.forEach(function (r) { r.classList.remove('mayas-v2-bogo__row--selected'); });
    if (status) status.textContent = defaultStatus;
  }

  function selectRow(row) {
    var sel = row.querySelector('.mayas-v2-bogo__size');
    var opt = sel.options[sel.selectedIndex];
    if (!opt || opt.disabled) return;
    rows.forEach(function (r) { r.classList.remove('mayas-v2-bogo__row--selected'); });
    row.classList.add('mayas-v2-bogo__row--selected');
    window.__mayasV2SelectedBogo = { variantId: opt.value };
    if (status) {
      status.textContent = row.querySelector('.mayas-v2-bogo__row-name').textContent.trim() + ' · ' + opt.text.trim();
    }
  }

  toggle.addEventListener('click', function () {
    var on = root.classList.toggle('mayas-v2-bogo--on');
    toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
    body.hidden = !on;
    if (on) {
      /* Preselect the first available row so one tap is a complete choice */
      var first = rows.filter(function (r) {
        var s = r.querySelector('.mayas-v2-bogo__size');
        return s.options[s.selectedIndex] && !s.options[s.selectedIndex].disabled;
      })[0];
      if (first) selectRow(first);
    } else {
      clearSelection();
    }
  });

  rows.forEach(function (row) {
    row.querySelector('[data-bogo-pick]').addEventListener('click', function () { selectRow(row); });
    row.querySelector('.mayas-v2-bogo__size').addEventListener('change', function () {
      if (row.classList.contains('mayas-v2-bogo__row--selected')) selectRow(row);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-fabric"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initFabricTabs() {
    var root = document.getElementById('mayas-v2-fabric');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.mayas-v2-fabric__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.mayas-v2-fabric__panel'));
    if (!tabs.length || !panels.length) return;

    function activate(target) {
      tabs.forEach(function(t) {
        var match = t.getAttribute('data-panel') === target;
        t.classList.toggle('mayas-v2-fabric__tab--active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.setAttribute('tabindex', match ? '0' : '-1');
      });
      panels.forEach(function(p) {
        var match = p.getAttribute('data-panel') === target;
        p.classList.toggle('mayas-v2-fabric__panel--active', match);
        if (match) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
      /* Tell initFabricVideos to re-evaluate which video should be playing -
         the previously hidden panel just became visible, and IO won't re-fire
         on its own since the video's geometry didn't change. */
      root.dispatchEvent(new CustomEvent('mayas-v2:fabric-tab-activated', {
        bubbles: true, detail: { target: target }
      }));
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activate(tab.getAttribute('data-panel'));
      });
      tab.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) currentIndex = 0;
        var nextIndex = e.key === 'ArrowRight'
          ? (currentIndex + 1) % tabs.length
          : (currentIndex - 1 + tabs.length) % tabs.length;
        var next = tabs[nextIndex];
        activate(next.getAttribute('data-panel'));
        next.focus();
      });
    });
  }

  /* ----------------------------------------------------------------
     Fabric videos - autoplay loop muted playsinline, lazy-loaded.
     Sources are rendered with data-src so the browser doesn't fetch
     bytes on initial parse. IntersectionObserver hydrates + plays on
     first viewport entry; pauses when scrolled out to save battery.
     Tab switches fire `mayas-v2:fabric-tab-activated` so we can play
     the newly visible panel's video (was display:none → couldn't play).
  ---------------------------------------------------------------- */
  function initFabricVideos() {
    var root = document.getElementById('mayas-v2-fabric');
    if (!root) return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-mayas-v2-fabric-video]'));
    if (!videos.length) return;

    function hydrate(video) {
      if (video.dataset.hydrated === '1') return;
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
        sources[i].removeAttribute('data-src');
      }
      video.setAttribute('preload', 'auto');
      video.load();
      video.dataset.hydrated = '1';
    }

    function isPanelVisible(video) {
      var panel = video.closest('.mayas-v2-fabric__panel');
      return panel && !panel.hasAttribute('hidden');
    }

    function tryPlay(video) {
      if (!isPanelVisible(video)) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function() { /* autoplay policy blocked - silent */ });
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            hydrate(v);
            tryPlay(v);
          } else if (v.dataset.hydrated === '1') {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      videos.forEach(function(v) { io.observe(v); });
    } else {
      videos.forEach(function(v) { hydrate(v); tryPlay(v); });
    }

    root.addEventListener('mayas-v2:fabric-tab-activated', function() {
      videos.forEach(function(v) {
        if (isPanelVisible(v)) {
          if (v.dataset.hydrated !== '1') hydrate(v);
          tryPlay(v);
        } else {
          v.pause();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFabricTabs();
      initFabricVideos();
    });
  } else {
    initFabricTabs();
    initFabricVideos();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Hero carousel - touch/swipe + thumbnail dot sync
  ---------------------------------------------------------------- */
  function initHeroCarousel() {
    const track = document.getElementById('mayas-v2-hero-track');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('.mayas-v2-hero__slide'));
    const thumbs = Array.from(document.querySelectorAll('.mayas-v2-hero__thumb'));
    if (slides.length < 2) return;

    let activeIdx = 0;

    function goTo(idx) {
      if (idx < 0 || idx >= slides.length) return;
      activeIdx = idx;
      track.scrollTo({ left: track.offsetWidth * idx, behavior: 'smooth' });
      slides.forEach(function(s, i) {
        s.classList.toggle('mayas-v2-hero__slide--active', i === idx);
        s.setAttribute('aria-hidden', i !== idx ? 'true' : 'false');
      });
      thumbs.forEach(function(t, i) {
        t.classList.toggle('mayas-v2-hero__thumb--active', i === idx);
        t.setAttribute('aria-selected', i === idx ? 'true' : 'false');
      });
    }

    thumbs.forEach(function(btn) {
      btn.addEventListener('click', function() {
        goTo(parseInt(btn.getAttribute('data-thumb-index'), 10));
      });
    });

    document.querySelectorAll('[data-hero-arrow]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        goTo(activeIdx + (btn.getAttribute('data-hero-arrow') === 'next' ? 1 : -1));
      });
    });

    var scrollTimer;
    track.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var newIdx = Math.round(track.scrollLeft / track.offsetWidth);
        if (newIdx !== activeIdx) goTo(newIdx);
      }, 80);
    }, { passive: true });

    /* Also update on scroll without smooth snap settling delay for snappy feedback */
    track.addEventListener('scrollend', function() {
      var newIdx = Math.round(track.scrollLeft / track.offsetWidth);
      if (newIdx !== activeIdx) goTo(newIdx);
    }, { passive: true });
  }

  /* ----------------------------------------------------------------
     Rotating micro-quotes - vertical slot rotation
  ---------------------------------------------------------------- */
  function initMicroQuotes() {
    var instances = document.querySelectorAll('.mayas-v2-micro-quotes');
    instances.forEach(function(root) {
      var viewport = root.querySelector('.mayas-v2-micro-quotes__viewport');
      if (!viewport) return;
      var quotes = Array.from(viewport.querySelectorAll('.mayas-v2-micro-quote'));
      if (quotes.length < 2) return;
      var interval = parseInt(root.getAttribute('data-rotation-ms'), 10) || 2000;
      var activeIdx = quotes.findIndex(function(q) {
        return q.classList.contains('mayas-v2-micro-quote--active');
      });
      if (activeIdx < 0) {
        activeIdx = 0;
        quotes[0].classList.add('mayas-v2-micro-quote--active');
      }

      function tick() {
        var current = quotes[activeIdx];
        var nextIdx = (activeIdx + 1) % quotes.length;
        var next = quotes[nextIdx];

        current.classList.remove('mayas-v2-micro-quote--active');
        current.classList.add('mayas-v2-micro-quote--exit');

        void next.offsetWidth;
        next.classList.add('mayas-v2-micro-quote--active');

        setTimeout(function() {
          current.classList.remove('mayas-v2-micro-quote--exit');
        }, 450);

        activeIdx = nextIdx;
      }

      setInterval(tick, interval);
    });
  }

  /* ----------------------------------------------------------------
     Price update on variant change
     Listens for Shopify's variant:change event emitted by
     mayas-v2-pdp-variants section.
  ---------------------------------------------------------------- */
  function initPriceUpdate() {
    var priceEl = document.getElementById('mayas-v2-price');
    if (!priceEl) return;
    var priceMap = {};
    try {
      priceMap = JSON.parse(priceEl.getAttribute('data-prices-by-id') || '{}');
    } catch (e) { priceMap = {}; }
    var shopLocale = priceEl.getAttribute('data-shop-locale') || 'en';
    var shopCurrency = priceEl.getAttribute('data-shop-currency') || 'DKK';
    document.addEventListener('mayas-v2:variant-change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      if (!variant.available) {
        priceEl.textContent = '';
        return;
      }
      var preformatted = priceMap[variant.id];
      if (preformatted) {
        priceEl.textContent = preformatted;
        return;
      }
      try {
        priceEl.textContent = new Intl.NumberFormat(shopLocale, {
          style: 'currency',
          currency: shopCurrency
        }).format(variant.price / 100);
      } catch (err) {
        priceEl.textContent = (variant.price / 100).toFixed(2) + ' ' + shopCurrency;
      }
    });
  }

  /* ----------------------------------------------------------------
     Title relocator - desktop two-column layout
     On >=768px the title/price/rating block moves to the top of the
     buy column (the variants section, which grid-places into column 2).
     On <768px it returns to its original spot under the gallery.
     Mirrors the initContribePillRelocator pattern in the ATC section.
     The mobile DOM/markup is unchanged - this only fires at desktop width.
  ---------------------------------------------------------------- */
  function initTitleRelocator() {
    var title = document.getElementById('mayas-v2-title');
    if (!title) return;
    var heroWrap = title.parentNode;
    var mq = window.matchMedia('(min-width: 768px)');

    function place(isDesktop) {
      var variants = document.getElementById('mayas-v2-variants');
      if (isDesktop) {
        if (variants && variants.firstChild !== title) {
          variants.insertBefore(title, variants.firstChild);
        }
      } else if (heroWrap && title.parentNode !== heroWrap) {
        heroWrap.appendChild(title);
      }
    }

    place(mq.matches);

    var raf;
    function onChange() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function() { place(mq.matches); });
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initHeroCarousel();
      initMicroQuotes();
      initPriceUpdate();
      initTitleRelocator();
    });
  } else {
    initHeroCarousel();
    initMicroQuotes();
    initPriceUpdate();
    initTitleRelocator();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-pads"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var DATA = {};
  try {
    var dataEl = document.getElementById('mayas-v2-pads-data');
    if (dataEl) { DATA = JSON.parse(dataEl.textContent || '{}'); }
  } catch (e) { DATA = {}; }

  function getRows() {
    var list = document.getElementById('mayas-v2-pads-list');
    return list ? Array.prototype.slice.call(list.querySelectorAll('.mayas-v2-pad')) : [];
  }

  function activeRow() {
    var list = document.getElementById('mayas-v2-pads-list');
    return list ? list.querySelector('.mayas-v2-pad--active') : null;
  }

  /* Push one slot's line-item id + price text into a row (or hide it). */
  function applyRow(row, slot) {
    if (!slot) {
      row.setAttribute('hidden', '');
      return;
    }
    row.removeAttribute('hidden');
    if (slot.id != null) row.setAttribute('data-pad-variant', String(slot.id));

    if (row.getAttribute('data-pad-is-bundle') === 'true') {
      if (slot.was) row.setAttribute('data-bundle-was', slot.was);
      if (slot.now) row.setAttribute('data-bundle-now', slot.now);
      if (slot.save) row.setAttribute('data-bundle-save', slot.save);
      var wasEl = row.querySelector('.mayas-v2-pad__price-was');
      var nowEl = row.querySelector('.mayas-v2-pad__price-now');
      var saveEl = row.querySelector('.mayas-v2-pad__save-tag');
      if (wasEl && slot.was) wasEl.textContent = slot.was;
      if (nowEl && slot.now) nowEl.textContent = '+ ' + slot.now;
      if (saveEl && slot.save) saveEl.textContent = slot.save;
    } else {
      var pWas = row.querySelector('.mayas-v2-pad__price-was');
      if (pWas && slot.price) pWas.textContent = slot.price;
    }
  }

  /* Refresh the collapsed summary from a row's current state. */
  function updateSummary(row) {
    var titleEl = document.getElementById('mayas-v2-pads-summary-title');
    var wasEl = document.getElementById('mayas-v2-pads-summary-was');
    var nowEl = document.getElementById('mayas-v2-pads-summary-now');
    var saveEl = document.getElementById('mayas-v2-pads-summary-save');
    var freeEl = document.getElementById('mayas-v2-pads-summary-free');
    var tagEl = document.getElementById('mayas-v2-pads-tag');
    var isBundle = row.getAttribute('data-pad-is-bundle') === 'true';

    if (titleEl) titleEl.textContent = row.getAttribute('data-pad-name') || '';

    /* Mirror the selected row's image into the collapsed card (desktop). */
    var thumbEl = document.getElementById('mayas-v2-pads-summary-thumb');
    if (thumbEl) {
      var rowImg = row.querySelector('.mayas-v2-pad__thumb-img');
      if (rowImg) {
        var clone = rowImg.cloneNode(true);
        clone.className = 'mayas-v2-pads__summary-thumb-img';
        thumbEl.innerHTML = '';
        thumbEl.appendChild(clone);
      } else {
        thumbEl.innerHTML = '';
      }
    }

    if (isBundle) {
      if (wasEl) { wasEl.textContent = row.getAttribute('data-bundle-was') || ''; wasEl.style.display = ''; }
      if (nowEl) { nowEl.textContent = '+ ' + (row.getAttribute('data-bundle-now') || ''); nowEl.style.display = ''; }
      if (saveEl) { saveEl.textContent = row.getAttribute('data-bundle-save') || ''; saveEl.style.display = ''; }
      if (freeEl) freeEl.style.display = 'none';
      if (tagEl) tagEl.textContent = tagEl.getAttribute('data-tag-bundle') || tagEl.textContent;
    } else {
      if (wasEl) wasEl.style.display = 'none';
      if (nowEl) nowEl.style.display = 'none';
      if (saveEl) saveEl.style.display = 'none';
      if (freeEl) freeEl.style.display = '';
      if (tagEl) tagEl.textContent = tagEl.getAttribute('data-tag-single') || tagEl.textContent;
    }
  }

  /* Mark a row selected; update the global selected-pad + summary + dispatch. */
  function selectRow(row, collapseAfter) {
    getRows().forEach(function(r) {
      r.classList.remove('mayas-v2-pad--active');
      r.setAttribute('aria-checked', 'false');
    });
    row.classList.add('mayas-v2-pad--active');
    row.setAttribute('aria-checked', 'true');

    window.__mayasV2SelectedPad = {
      variantId: row.getAttribute('data-pad-variant'),
      name: row.getAttribute('data-pad-name') || '',
      isBundle: row.getAttribute('data-pad-is-bundle') === 'true'
    };

    updateSummary(row);

    document.dispatchEvent(new CustomEvent('mayas-v2:pad-change', {
      bubbles: true,
      detail: window.__mayasV2SelectedPad
    }));

    if (collapseAfter) {
      var toggle = document.getElementById('mayas-v2-pads-toggle');
      var list = document.getElementById('mayas-v2-pads-list');
      setTimeout(function() {
        if (toggle) toggle.setAttribute('aria-expanded', 'false');
        if (list) list.setAttribute('hidden', '');
      }, 280);
    }
  }

  /* Swap every row to the slot data for the given garment variant id. */
  function applyVariant(variantId) {
    var slots = DATA[String(variantId)];
    if (!slots) return;
    var rows = getRows();
    rows.forEach(function(row) {
      applyRow(row, slots[row.getAttribute('data-pad-key')]);
    });

    var act = activeRow();
    if (!act || act.hasAttribute('hidden')) {
      var firstVisible = rows.filter(function(r) { return !r.hasAttribute('hidden'); })[0];
      if (firstVisible) selectRow(firstVisible, false);
    } else {
      /* Re-select so the size-correct line-item id + summary stay current. */
      selectRow(act, false);
    }
  }

  function init() {
    var root = document.getElementById('mayas-v2-pads');
    if (!root) return;
    var toggle = document.getElementById('mayas-v2-pads-toggle');
    var list = document.getElementById('mayas-v2-pads-list');
    var rows = getRows();
    if (!toggle || !list || !rows.length) return;

    /* Seed selection from the server-rendered active row. */
    var act = activeRow() || rows[0];
    selectRow(act, false);

    /* Sync to the current variant (handles ?variant= deep links + size-correct ids). */
    var input = document.getElementById('mayas-v2-variant-id');
    if (input && input.value) applyVariant(input.value);

    /* Collapse / expand */
    toggle.addEventListener('click', function() {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      if (isOpen) { list.setAttribute('hidden', ''); }
      else { list.removeAttribute('hidden'); }
    });

    /* Row selection */
    rows.forEach(function(row) {
      row.addEventListener('click', function() { selectRow(row, true); });
    });

    /* Swap pad data when the garment variant changes. */
    document.addEventListener('mayas-v2:variant-change', function(e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.id) return;
      applyVariant(v.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-perf"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initPerfSlider(slider) {
    var clip    = slider.querySelector('[data-perf-clip]');
    var divider = slider.querySelector('[data-perf-divider]');
    if (!clip || !divider) return;

    var pos = 50;
    var dragging = false;

    function setPos(percent) {
      percent = Math.max(0, Math.min(100, percent));
      pos = percent;
      slider.style.setProperty('--perf-pos', percent + '%');
    }

    function pointerToPercent(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      divider.setPointerCapture && e.pointerId && divider.setPointerCapture(e.pointerId);
      setPos(pointerToPercent(e.clientX));
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      setPos(pointerToPercent(e.clientX));
    }

    function onUp() {
      dragging = false;
    }

    divider.addEventListener('pointerdown', onDown);
    divider.addEventListener('pointermove', onMove);
    divider.addEventListener('pointerup', onUp);
    divider.addEventListener('pointercancel', onUp);
    divider.addEventListener('click', function(e) { e.preventDefault(); });
  }

  function initPerfCarousel(carousel) {
    var rail = carousel.querySelector('[data-perf-rail]');
    var prev = carousel.querySelector('[data-perf-prev]');
    var next = carousel.querySelector('[data-perf-next]');
    if (!rail || !prev || !next) return;

    function step() {
      var card = rail.querySelector('.mayas-v2-perf-card');
      if (!card) return rail.clientWidth * 0.8;
      var styles = getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= max;
    }

    prev.addEventListener('click', function() {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', function() {
      window.requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-perf-slider]'))
      .forEach(initPerfSlider);
    Array.prototype.slice
      .call(document.querySelectorAll('.mayas-v2-perf__carousel'))
      .forEach(initPerfCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v2-pdp-variants"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* ----------------------------------------------------------------
     Size grid - variant selection + cross-section event dispatch
  ---------------------------------------------------------------- */
  function initSizeGrid() {
    var grid = document.getElementById('mayas-v2-size-grid');
    if (!grid) return;
    var btns = Array.from(grid.querySelectorAll('.mayas-v2-size'));
    if (!btns.length) return;

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId     = btn.getAttribute('data-variant-id');
        var variantPrice  = parseInt(btn.getAttribute('data-variant-price'), 10);
        var priceStr      = btn.getAttribute('data-variant-price-formatted') || '';
        var available     = btn.getAttribute('data-variant-available') !== 'false';
        var inventory     = parseInt(btn.getAttribute('data-variant-inventory'), 10) || 0;
        var state         = btn.getAttribute('data-variant-state') || 'in';
        var title         = btn.getAttribute('data-variant-title') || '';
        var preorderEta   = btn.getAttribute('data-preorder-eta') || '';

        /* Update active state */
        btns.forEach(function(b) {
          b.classList.remove('mayas-v2-size--active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('mayas-v2-size--active');
        btn.setAttribute('aria-pressed', 'true');

        /* Push variant change event for hero (price) + ATC (form) */
        document.dispatchEvent(new CustomEvent('mayas-v2:variant-change', {
          bubbles: true,
          detail: {
            variantId: variantId,
            variant: {
              id: variantId,
              price: variantPrice,
              price_formatted: priceStr,
              available: available,
              inventory_quantity: inventory,
              state: state,
              title: title
            }
          }
        }));

        /* Update stock bar */
        updateStockBar({ available: available, inventory_quantity: inventory, state: state, title: title, preorderEta: preorderEta });

        /* Update URL without reload */
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variantId);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ----------------------------------------------------------------
     Stock bar update - responds to variant selection
  ---------------------------------------------------------------- */
  function updateStockBar(variant) {
    var bar    = document.getElementById('mayas-v2-stock-bar');
    var fill   = document.getElementById('mayas-v2-stock-fill');
    var status = bar ? bar.querySelector('.mayas-v2-stock-bar__status') : null;
    if (!bar || !fill || !status) return;

    /* Locale strings are bridged in via data-label-* attrs on the stock-bar root,
       populated by Liquid `| t` filters at render time. JS reads the active
       locale's copy without re-implementing translation. */
    var state = variant.state || 'in';
    var pct;
    var label;

    switch (state) {
      case 'remote':
        pct = 100;
        label = bar.getAttribute('data-label-remote') || '';
        break;
      case 'preorder':
        pct = 100;
        label = bar.getAttribute('data-label-preorder') || '';
        break;
      case 'out':
        pct = 0;
        label = bar.getAttribute('data-label-out') || '';
        break;
      case 'low':
        var n = variant.inventory_quantity || 0;
        pct = n * 20;
        label = (bar.getAttribute('data-label-low-template') || '').replace('__N__', n);
        break;
      default:
        pct = 76;
        label = bar.getAttribute('data-label-ready') || '';
    }

    bar.className = 'mayas-v2-stock-bar mayas-v2-stock-bar--' + state;
    fill.style.width = pct + '%';
    status.textContent = label;

    /* Update size label in stock bar */
    var sizeLabel = document.getElementById('mayas-v2-stock-size');
    if (sizeLabel && variant.title) {
      sizeLabel.textContent = variant.title;
    }

    /* Update preorder ETA from variant metafield (mayas.preorder_ship_date,
       pre-formatted in Liquid as "%-d %b" and passed via data-preorder-eta).
       Locale strings come from data-label-preorder-ships-template / -eta on
       the stock-bar root. */
    var etaEl = document.getElementById('mayas-v2-preorder-eta');
    if (etaEl) {
      if (variant.preorderEta) {
        var tmpl = bar.getAttribute('data-label-preorder-ships-template') || '';
        etaEl.textContent = tmpl.replace('__D__', variant.preorderEta);
      } else {
        etaEl.textContent = bar.getAttribute('data-label-preorder-eta') || '';
      }
    }
  }

  function initFindSizeChip() {
    var chip = document.getElementById('mayas-v2-find-size-chip');
    if (!chip) return;
    chip.addEventListener('click', function(e) {
      e.preventDefault();
      /* Wair's app JS injects #wair-fit-advisor; it origin-gates itself
         (400 from its load endpoint on localhost/theme-dev, occasional 400s
         on live), so the button may never appear. Poll 4s, then fall back
         to the size-guide page instead of a silently dead click. */
      var deadline = Date.now() + 4000;
      (function tryOpen() {
        var w = document.getElementById('wair-fit-advisor');
        if (w) { w.click(); return; }
        if (Date.now() < deadline) { window.requestAnimationFrame(tryOpen); return; }
        var g = document.querySelector('.mayas-v2-variants__guide-link');
        if (g && g.getAttribute('href') && g.getAttribute('href') !== '#') window.location.href = g.href;
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeGrid();
      initFindSizeChip();
    });
  } else {
    initSizeGrid();
    initFindSizeChip();
  }
})();

/* Back-in-stock notify -> Klaviyo Back in Stock subscription (client API).
   Direct POST to Klaviyo's public /client/ endpoint (company SgwkrS) so the
   capture does NOT depend on klaviyo.js having loaded; the legacy /onsite/
   endpoint is CORS-blocked from the storefront - never use it. Klaviyo's
   Shopify integration watches inventory and fires the Back in Stock flow;
   opens/clicks/conversions live in Klaviyo analytics. */
(function(){
  var COMPANY = 'SgwkrS';
  /* window.fetch on this page is monkey-patched by several third parties
     (Shopify web-pixels, shop_events_listener, RestockRocket, klaviyo.js) and
     the wrapped chain can hard-fail cross-origin POSTs (TypeError before any
     HTTP status). Verified 2026-07-06: wrapped fetch + XHR both die while a
     pristine same-origin iframe fetch returns 202. Fall back to a pristine
     fetch whenever the page's fetch throws at network level. */
  function pristineFetch(url, opts) {
    var ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    var f = ifr.contentWindow && ifr.contentWindow.fetch;
    if (!f) { ifr.remove(); return Promise.reject(new Error('no iframe fetch')); }
    return f.call(ifr.contentWindow, url, opts).finally(function(){ ifr.remove(); });
  }
  function bisFetch(url, opts) {
    return fetch(url, opts).catch(function(){ return pristineFetch(url, opts); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-notify-btn]');
    if (!btn) return;
    var wrap = btn.closest('.mayas-v2-stock-bar__notify');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="email"]');
    var msg = wrap.querySelector('[data-notify-msg]');
    var email = input ? input.value.trim() : '';
    var active = document.querySelector('.mayas-v2-size--active[data-variant-id]') ||
                 document.querySelector('[data-variant-id][aria-pressed="true"]');
    var variantId = active ? active.getAttribute('data-variant-id') : '';
    function show(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('is-error', !!isError);
    }
    if (!email || email.indexOf('@') < 1) { if (input) input.focus(); return; }
    if (!variantId) return;
    btn.disabled = true;
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    bisFetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(payload)
    }).then(function(r){
      if (r.status === 202 || r.ok) {
        if (input) input.value = '';
        show(wrap.getAttribute('data-msg-success') || 'OK', false);
      } else {
        return Promise.reject(new Error('BIS status ' + r.status));
      }
    }).catch(function(err){
      btn.disabled = false;
      show(wrap.getAttribute('data-msg-error') || 'Error', true);
      console.warn('[mayas-v2] Klaviyo BIS subscribe failed', err);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-atc"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* B6 (2026-09-24): tracking lives outside addToCart() so the add function can be
     swapped without touching it. Nothing here changes what the shopper sees. */
  function track(name, props) {
    if (typeof window.themeTrack !== 'function') return;
    var root = document.getElementById('mayas-v3-atc');
    var p = props || {};
    if (root) {
      p.product_id = Number(root.getAttribute('data-product-id')) || root.getAttribute('data-product-id');
      p.product_handle = root.getAttribute('data-product-handle') || '';
    }
    try { window.themeTrack(name, p); } catch (e) {}
  }

  /* The size the shopper has chosen (null when none). */
  function chosenSize() {
    var input = document.getElementById('mayas-v3-variant-id');
    if (!input || !input.value) return null;
    var btn = document.querySelector('.mayas-v3-size[data-variant-id="' + input.value + '"]');
    var grid = document.getElementById('mayas-v3-size-grid');
    var via = grid ? (grid.getAttribute('data-select-via') || '') : '';
    return {
      size: btn ? (btn.getAttribute('data-variant-title') || '') : '',
      stock_state: btn ? (btn.getAttribute('data-variant-state') || '') : '',
      size_preselected: via !== 'tap'
    };
  }

  /* B3: returns true when the tap must become a "choose a size" prompt instead of an add. */
  function promptIfNoSize(button) {
    if (chosenSize()) return false;
    document.dispatchEvent(new CustomEvent('mayas-v3:size-prompt', { detail: { button: button } }));
    return true;
  }

  function trackAtc(button) {
    var s = chosenSize();
    if (!s) return;
    track('atc_clicked', {
      button: button,
      size: s.size,
      stock_state: s.stock_state,
      size_preselected: s.size_preselected
    });
  }

  function initAtcVariantSync() {
    var atcRoot     = document.getElementById('mayas-v3-atc');
    var hiddenInput = document.getElementById('mayas-v3-variant-id');
    var btnLabel    = document.getElementById('mayas-v3-atc-btn-label');
    var btnPrice    = document.getElementById('mayas-v3-atc-btn-price');
    var atcBtn      = document.getElementById('mayas-v3-atc-btn');
    var stickyBtn   = document.getElementById('mayas-v3-sticky-btn');
    var stickyLabel = document.getElementById('mayas-v3-sticky-btn-label');
    var stickyPrice = document.getElementById('mayas-v3-sticky-btn-price');

    document.addEventListener('mayas-v3:variant-change', function(e) {
      var detail  = e.detail || {};
      var variant = detail.variant || {};
      if (!variant.id) return;

      if (hiddenInput) hiddenInput.value = variant.id;
      if (atcRoot && variant.state) atcRoot.setAttribute('data-stock-state', variant.state);

      if (atcBtn && btnLabel && atcRoot) {
        var isPreorderProduct = atcRoot.getAttribute('data-preorder') === 'true';
        var labelOos      = atcRoot.getAttribute('data-label-sold-out')  || '';
        var labelPreorder = atcRoot.getAttribute('data-label-pre-order') || '';
        var labelAdd      = atcRoot.getAttribute('data-label-add')       || '';

        if (variant.state === 'out') {
          btnLabel.textContent = labelOos;
          atcBtn.classList.add('mayas-v3-atc__btn--oos');
          atcBtn.setAttribute('aria-disabled', 'true');
        } else if (variant.state === 'preorder' || isPreorderProduct) {
          btnLabel.textContent = labelPreorder;
          atcBtn.classList.remove('mayas-v3-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        } else {
          btnLabel.textContent = labelAdd;
          atcBtn.classList.remove('mayas-v3-atc__btn--oos');
          atcBtn.removeAttribute('aria-disabled');
        }
        atcBtn.setAttribute('aria-label', btnLabel.textContent);
      }

      var shopLocale = atcRoot ? (atcRoot.getAttribute('data-shop-locale') || 'en') : 'en';
      var shopCurrency = atcRoot ? (atcRoot.getAttribute('data-shop-currency') || 'DKK') : 'DKK';

      /* Money: Liquid-formatted string first; Intl only for derived numbers. */
      function toFormatted(cents) {
        try {
          return new Intl.NumberFormat(shopLocale, { style: 'currency', currency: shopCurrency }).format(cents / 100);
        } catch (err) {
          return (cents / 100).toFixed(2) + ' ' + shopCurrency;
        }
      }

      if (btnPrice) {
        if (variant.price_formatted) {
          btnPrice.textContent = variant.price_formatted;
        } else if (variant.price) {
          btnPrice.textContent = toFormatted(variant.price);
        }
      }

      /* S1: the sticky button is a mirror of the main one (label, price, sold-out look). */
      if (stickyBtn && atcBtn) {
        if (stickyLabel && btnLabel) stickyLabel.textContent = btnLabel.textContent;
        if (stickyPrice && btnPrice) stickyPrice.textContent = btnPrice.textContent;
        stickyBtn.classList.toggle('mayas-v3-atc__btn--oos', atcBtn.classList.contains('mayas-v3-atc__btn--oos'));
        if (atcBtn.getAttribute('aria-disabled') === 'true') {
          stickyBtn.setAttribute('aria-disabled', 'true');
        } else {
          stickyBtn.removeAttribute('aria-disabled');
        }
        stickyBtn.setAttribute('aria-label', atcBtn.getAttribute('aria-label') || '');
      }
    });
  }

  /* Cart add: garment + pad lines in ONE /cart/add.js items call.
     Pads rule 2026-09-24: goes through the shared window.themeAddToCart
     (assets/theme-add-to-cart.js, loaded on every page from the cart drawer) with the
     variant's own metafield pads from mayas-v3-pdp-pads. The inline fetch below is the
     fallback only, for a page where the shared file failed to load. */
  function addToCart() {
    var mainIdEl = document.getElementById('mayas-v3-variant-id');
    if (!mainIdEl || !mainIdEl.value) return Promise.reject(new Error('no-variant'));

    if (typeof window.themeAddToCart === 'function') {
      var sharedPads = (window.__mayasV3PadItems || []).filter(Boolean);
      var sharedBogo = window.__mayasV3SelectedBogo;
      return window.themeAddToCart(mainIdEl.value, {
        quantity: 1,
        source: 'pdp_v3',
        pads: sharedPads,
        extra: (sharedBogo && sharedBogo.variantId) ? [{ id: sharedBogo.variantId, quantity: 1 }] : []
      }).then(function(data) {
        document.dispatchEvent(new CustomEvent('cart:added', {
          bubbles: true,
          detail: { items: (data && data.items) || [], response: data }
        }));
        return data;
      });
    }

    var items = [{ id: mainIdEl.value, quantity: 1 }];

    var pads = window.__mayasV3PadItems;
    if (pads && pads.length) {
      pads.forEach(function(id) {
        if (id) items.push({ id: String(id), quantity: 1 });
      });
    }

    var bogo = window.__mayasV3SelectedBogo;
    if (bogo && bogo.variantId) {
      items.push({ id: bogo.variantId, quantity: 1 });
    }

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(err) { throw err; });
      return r.json();
    })
    .then(function(data) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: { source: 'mayas-v3-atc' }
      }));
      document.dispatchEvent(new CustomEvent('cart:added', {
        bubbles: true,
        detail: { items: items, response: data }
      }));
      var drawerTrigger = document.querySelector('[aria-controls="cart-drawer"]');
      if (drawerTrigger) {
        drawerTrigger.click();
      } else {
        window.location.href = '/cart';
      }
      return data;
    });
  }

  function initAtcSubmit() {
    var form = document.getElementById('mayas-v3-product-form');
    if (!form) return;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = document.getElementById('mayas-v3-atc-btn');
      if (promptIfNoSize('main')) return;
      trackAtc('main');
      if (btn && btn.getAttribute('aria-disabled') === 'true') return;
      if (btn) btn.setAttribute('aria-busy', 'true');
      addToCart().catch(function(err) {
        console.error('[mayas-v3 ATC]', err);
        window.location.href = '/cart';
      }).then(function() {
        if (btn) btn.removeAttribute('aria-busy');
      });
    });
  }

  /* Sticky ATC (S1): visible whenever the main button row is out of the viewport. */
  function initStickyAtc() {
    var sticky  = document.getElementById('mayas-v3-sticky-atc');
    var trigger = document.getElementById('mayas-v3-atc-btn');
    if (!sticky || !trigger) return;

    var stickyBtn = document.getElementById('mayas-v3-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        if (promptIfNoSize('sticky')) return;
        trackAtc('sticky');
        var mainBtn = document.getElementById('mayas-v3-atc-btn');
        if (mainBtn && mainBtn.getAttribute('aria-disabled') === 'true') {
          /* Sold out: go to the email notify form when this product has one. */
          var notify = document.querySelector('.mayas-v3-atc__notify');
          var target = (notify && notify.offsetParent) ? notify : mainBtn;
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var email = (target === notify) ? notify.querySelector('input[type="email"]') : null;
          if (email) {
            try { email.focus({ preventScroll: true }); } catch (err) { email.focus(); }
          }
          return;
        }
        stickyBtn.setAttribute('aria-busy', 'true');
        addToCart().catch(function(err) {
          console.error('[mayas-v3 sticky ATC]', err);
          window.location.href = '/cart';
        }).then(function() {
          stickyBtn.removeAttribute('aria-busy');
        });
      });
    }

    function setVisible(on) {
      sticky.classList.toggle('mayas-v3-sticky-atc--visible', on);
      sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
    }

    /* S1 (Marcus 2026-09-24, Q87/Q88): the strip lives in its natural place, the slot
       directly under the stock card. Scrolling down, it moves up with the page until it
       reaches the bottom line of the screen (screen height minus its own height, safe
       area included); it can never go above that line, so from there on it stays pinned
       at the bottom all the way down, over community, reviews and footer. It is never
       shown above its slot (top = max(slot top, bottom line)). Scrolling back up past
       the slot returns it to the slot. Hidden while the email field of the notify form
       has focus (keyboard open). Phones only; desktop never shows the strip. */
    var slot = document.getElementById('mayas-v3-atc-slot');
    var typing = false;
    var raf = 0;
    /* The slot is a zero-height marker under the stock card: nothing ever reserves
       space for the strip, so there is no gap and nothing to switch. While the strip
       sits in its slot (not yet pinned) it covers everything from the marker to the
       bottom of the screen, which is exactly the content that would otherwise be below
       it (payment icons and the rest start at the marker, hidden behind the white
       strip). Once the marker reaches the bottom line the strip is pinned and the page
       simply scrolls on under it. The button sits 16px under the stock card (strip
       padding 4px, so the strip starts 4px above the marker, which is 16px + 4px below
       the card via the section padding). */
    function place() {
      raf = 0;
      if (window.innerWidth >= 768 || !slot) { setVisible(false); return; }
      var line = window.innerHeight - sticky.offsetHeight;
      var natural = slot.getBoundingClientRect().top - 4;
      var drop = Math.max(0, Math.round(natural - line));
      sticky.style.transform = drop ? 'translateY(' + drop + 'px)' : '';
      setVisible(!typing);
    }
    function schedule() { if (!raf) raf = window.requestAnimationFrame(place); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule);
    document.addEventListener('focusin', function(e) {
      if (e.target.matches && e.target.matches('.mayas-v3-atc__notify input')) { typing = true; schedule(); }
    });
    document.addEventListener('focusout', function(e) {
      if (e.target.matches && e.target.matches('.mayas-v3-atc__notify input')) { typing = false; schedule(); }
    });
    place();
  }

  function init() {
    initAtcVariantSync();
    initAtcSubmit();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-fabric"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initFabricTabs() {
    var root = document.getElementById('mayas-v3-fabric');
    if (!root) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.mayas-v3-fabric__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.mayas-v3-fabric__panel'));
    if (!tabs.length || !panels.length) return;

    function activate(target) {
      tabs.forEach(function(t) {
        var match = t.getAttribute('data-panel') === target;
        t.classList.toggle('mayas-v3-fabric__tab--active', match);
        t.setAttribute('aria-selected', match ? 'true' : 'false');
        t.setAttribute('tabindex', match ? '0' : '-1');
      });
      panels.forEach(function(p) {
        var match = p.getAttribute('data-panel') === target;
        p.classList.toggle('mayas-v3-fabric__panel--active', match);
        if (match) {
          p.removeAttribute('hidden');
        } else {
          p.setAttribute('hidden', '');
        }
      });
      /* Tell initFabricVideos to re-evaluate which video should be playing -
         the previously hidden panel just became visible, and IO won't re-fire
         on its own since the video's geometry didn't change. */
      root.dispatchEvent(new CustomEvent('mayas-v3:fabric-tab-activated', {
        bubbles: true, detail: { target: target }
      }));
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        activate(tab.getAttribute('data-panel'));
      });
      tab.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var currentIndex = tabs.indexOf(document.activeElement);
        if (currentIndex === -1) currentIndex = 0;
        var nextIndex = e.key === 'ArrowRight'
          ? (currentIndex + 1) % tabs.length
          : (currentIndex - 1 + tabs.length) % tabs.length;
        var next = tabs[nextIndex];
        activate(next.getAttribute('data-panel'));
        next.focus();
      });
    });
  }

  /* ----------------------------------------------------------------
     Fabric videos - autoplay loop muted playsinline, lazy-loaded.
     Sources are rendered with data-src so the browser doesn't fetch
     bytes on initial parse. IntersectionObserver hydrates + plays on
     first viewport entry; pauses when scrolled out to save battery.
     Tab switches fire `mayas-v3:fabric-tab-activated` so we can play
     the newly visible panel's video (was display:none → couldn't play).
  ---------------------------------------------------------------- */
  function initFabricVideos() {
    var root = document.getElementById('mayas-v3-fabric');
    if (!root) return;
    var videos = Array.prototype.slice.call(root.querySelectorAll('[data-mayas-v3-fabric-video]'));
    if (!videos.length) return;

    function hydrate(video) {
      if (video.dataset.hydrated === '1') return;
      var sources = video.querySelectorAll('source[data-src]');
      for (var i = 0; i < sources.length; i++) {
        sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
        sources[i].removeAttribute('data-src');
      }
      video.setAttribute('preload', 'auto');
      video.load();
      video.dataset.hydrated = '1';
    }

    function isPanelVisible(video) {
      var panel = video.closest('.mayas-v3-fabric__panel');
      return panel && !panel.hasAttribute('hidden');
    }

    function tryPlay(video) {
      if (!isPanelVisible(video)) return;
      var p = video.play();
      if (p && typeof p.catch === 'function') {
        p.catch(function() { /* autoplay policy blocked - silent */ });
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            hydrate(v);
            tryPlay(v);
          } else if (v.dataset.hydrated === '1') {
            v.pause();
          }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      videos.forEach(function(v) { io.observe(v); });
    } else {
      videos.forEach(function(v) { hydrate(v); tryPlay(v); });
    }

    root.addEventListener('mayas-v3:fabric-tab-activated', function() {
      videos.forEach(function(v) {
        if (isPanelVisible(v)) {
          if (v.dataset.hydrated !== '1') hydrate(v);
          tryPlay(v);
        } else {
          v.pause();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFabricTabs();
      initFabricVideos();
    });
  } else {
    initFabricTabs();
    initFabricVideos();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  var MODEL_RE = /^\s*([A-Za-z0-9]+)\s*-\s*(\d{2,3})\s*cm\s*$/i;

  function initHeroCarousel() {
    var track = document.getElementById('mayas-v3-hero-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.mayas-v3-hero__slide'));
    var dashes = Array.prototype.slice.call(document.querySelectorAll('.mayas-v3-hero__dash'));
    var modelRoot = document.getElementById('mayas-v3-model');
    var modelBtn = document.getElementById('mayas-v3-model-btn');
    var modelText = document.getElementById('mayas-v3-model-text');
    var modelBand = document.getElementById('mayas-v3-model-band');
    var modelTemplate = modelRoot ? (modelRoot.getAttribute('data-template') || '') : '';
    var activeIdx = 0;

    function modelSentence(raw) {
      var m = MODEL_RE.exec(raw || '');
      if (!m || !modelTemplate) return raw;
      return modelTemplate.replace('__H__', m[2]).replace('__S__', m[1].toUpperCase());
    }

    function setBandOpen(open) {
      if (!modelBand) return;
      // Toggling one class only: swiping between two slides that both carry a model
      // entry swaps the text while the band stays open, so it never re-animates.
      modelBand.classList.toggle('is-open', open);
      modelBand.setAttribute('aria-hidden', open ? 'false' : 'true');
    }

    function syncModel() {
      if (!modelBtn || !modelText) return;
      var raw = slides[activeIdx] ? (slides[activeIdx].getAttribute('data-model-info') || '').trim() : '';
      if (!raw) {
        // Swiping to a slide without a model entry hides the chip and closes the band.
        modelBtn.hidden = true;
        modelBtn.setAttribute('aria-expanded', 'false');
        setBandOpen(false);
        return;
      }
      modelBtn.hidden = false;
      modelText.textContent = modelSentence(raw);
      setBandOpen(modelBtn.getAttribute('aria-expanded') === 'true');
    }

    function setActive(idx) {
      if (idx < 0 || idx >= slides.length) return;
      activeIdx = idx;
      slides.forEach(function(s, i) {
        s.classList.toggle('mayas-v3-hero__slide--active', i === idx);
      });
      dashes.forEach(function(d, i) {
        d.classList.toggle('mayas-v3-hero__dash--active', i === idx);
      });
      if (modelRoot) {
        // The last slide snaps to the right edge on mobile, so the caption follows it.
        var atEnd = slides.length > 1 && idx === slides.length - 1 && window.innerWidth < 768;
        modelRoot.classList.toggle('mayas-v3-model--end', atEnd);
        if (modelBand) modelBand.classList.toggle('mayas-v3-model-band--end', atEnd);
      }
      syncModel();
    }

    function nearestIndex() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function(s, i) {
        var dist = Math.abs(s.offsetLeft - track.offsetLeft - left);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }

    function goTo(idx) {
      if (idx < 0 || idx >= slides.length) return;
      track.scrollTo({ left: slides[idx].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      setActive(idx);
    }

    if (modelBtn) {
      modelBtn.addEventListener('click', function() {
        var open = modelBtn.getAttribute('aria-expanded') === 'true';
        modelBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        syncModel();
      });
    }

    document.querySelectorAll('[data-hero-arrow]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        goTo(activeIdx + (btn.getAttribute('data-hero-arrow') === 'next' ? 1 : -1));
      });
    });

    var raf = 0;
    track.addEventListener('scroll', function() {
      if (raf) return;
      raf = window.requestAnimationFrame(function() {
        raf = 0;
        var idx = nearestIndex();
        if (idx !== activeIdx) setActive(idx);
      });
    }, { passive: true });

    setActive(0);

    // Rating anchor scrolls to the reviews block (no-op when it is absent).
    var ratingLink = document.getElementById('mayas-v3-title-rating');
    if (ratingLink) {
      ratingLink.addEventListener('click', function(e) {
        var target = document.getElementById('mayas-v3-reviews');
        e.preventDefault();
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function initPriceUpdate() {
    var priceEl = document.getElementById('mayas-v3-price');
    var saleEl = document.getElementById('mayas-v3-price-sale');
    var cmpEl = document.getElementById('mayas-v3-price-compare');
    var cmpVal = document.getElementById('mayas-v3-price-compare-value');
    if (!priceEl || !saleEl) return;
    var priceMap = {};
    try {
      priceMap = JSON.parse(priceEl.getAttribute('data-prices-by-id') || '{}');
    } catch (e) { priceMap = {}; }
    var shopLocale = priceEl.getAttribute('data-shop-locale') || 'en';
    var shopCurrency = priceEl.getAttribute('data-shop-currency') || 'DKK';

    document.addEventListener('mayas-v3:variant-change', function(e) {
      var variant = e.detail && e.detail.variant;
      if (!variant) return;
      priceEl.classList.toggle('mayas-v3-title__price--hidden', !variant.available);
      var entry = priceMap[variant.id];
      var sale = entry ? entry[0] : '';
      var compare = entry ? entry[1] : '';
      if (!sale) {
        try {
          sale = new Intl.NumberFormat(shopLocale, { style: 'currency', currency: shopCurrency }).format(variant.price / 100);
        } catch (err) {
          sale = (variant.price / 100).toFixed(2) + ' ' + shopCurrency;
        }
      }
      saleEl.textContent = sale;
      saleEl.classList.toggle('mayas-v3-title__price-sale--discounted', !!compare);
      if (cmpEl && cmpVal) {
        cmpVal.textContent = compare || '';
        cmpEl.hidden = !compare;
      }
    });
  }

  function initTitleRelocator() {
    var title = document.getElementById('mayas-v3-title');
    if (!title) return;
    var heroWrap = title.parentNode;
    var mq = window.matchMedia('(min-width: 768px)');

    function place(isDesktop) {
      var variants = document.getElementById('mayas-v3-variants');
      if (isDesktop) {
        if (variants && variants.firstChild !== title) {
          variants.insertBefore(title, variants.firstChild);
        }
      } else if (heroWrap && title.parentNode !== heroWrap) {
        heroWrap.appendChild(title);
      }
    }

    place(mq.matches);
    var raf;
    function onChange() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function() { place(mq.matches); });
    }
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else if (mq.addListener) {
      mq.addListener(onChange);
    }
  }

  /* B6 (2026-09-24): gallery_image_viewed. One event per image view, sent when the
     shopper moves on to another image or leaves (tab hidden / page hide), with the
     time that image was the active slide (dwell_ms). via = how she got there:
     load (first image on page load), swipe, arrow (desktop arrows), resume (came
     back to the tab). A swipe counts once the track has settled for 180 ms, so a
     half-swipe that springs back is not a view. Invisible: tracking only. */
  function initGalleryTracking() {
    var track = document.getElementById('mayas-v3-hero-track');
    var root = document.getElementById('mayas-v3-top');
    if (!track || !root) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.mayas-v3-hero__slide'));
    if (!slides.length) return;
    var productId = Number(root.getAttribute('data-product-id')) || root.getAttribute('data-product-id');
    var productHandle = root.getAttribute('data-product-handle') || '';
    var current = null;
    var pendingVia = '';
    var timer = 0;

    function nearest() {
      var left = track.scrollLeft;
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function(s, i) {
        var dist = Math.abs(s.offsetLeft - track.offsetLeft - left);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      if (slides.length > 1 && track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }

    function open(idx, via) {
      current = { idx: idx, start: Date.now(), via: via };
    }

    function close() {
      if (!current) return;
      var view = current;
      current = null;
      if (typeof window.themeTrack !== 'function') return;
      var s = slides[view.idx];
      if (!s) return;
      try {
        window.themeTrack('gallery_image_viewed', {
          image_position: Number(s.getAttribute('data-media-position')) || view.idx + 1,
          image_media_id: Number(s.getAttribute('data-media-id')) || s.getAttribute('data-media-id'),
          image_filename: s.getAttribute('data-media-filename') || '',
          dwell_ms: Math.max(0, Date.now() - view.start),
          via: view.via,
          product_id: productId,
          product_handle: productHandle
        });
      } catch (e) {}
    }

    function settle() {
      timer = 0;
      if (document.visibilityState === 'hidden') return;
      var idx = nearest();
      if (current && current.idx === idx) { pendingVia = ''; return; }
      close();
      open(idx, pendingVia || 'swipe');
      pendingVia = '';
    }

    track.addEventListener('scroll', function() {
      if (timer) clearTimeout(timer);
      timer = setTimeout(settle, 180);
    }, { passive: true });

    Array.prototype.forEach.call(document.querySelectorAll('[data-hero-arrow]'), function(btn) {
      btn.addEventListener('click', function() { pendingVia = 'arrow'; });
    });

    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'hidden') {
        close();
      } else if (!current) {
        open(nearest(), 'resume');
      }
    });
    window.addEventListener('pagehide', close);

    open(nearest(), 'load');
  }

  /* 2026-09-24 (Marcus): drag-to-swipe with a mouse or pen. A native scroll-snap track
     only scrolls by touch, wheel or trackpad; a mouse drag did nothing (desktop Chrome
     at phone width). Touch is left entirely to the browser. While dragging, snap is
     switched off and scrollLeft follows the pointer 1:1; on release the track glides to
     the nearest slide (one step on a short flick) and snap comes back. A drag of more
     than 6 px swallows the click that follows, so nothing behind it fires. */
  function initMouseDrag() {
    var track = document.getElementById('mayas-v3-hero-track');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.mayas-v3-hero__slide'));
    if (slides.length < 2) return;
    var drag = null;

    function leftOf(i) {
      var max = track.scrollWidth - track.clientWidth;
      return Math.max(0, Math.min(max, slides[i].offsetLeft - track.offsetLeft));
    }
    function nearest() {
      var best = 0;
      var bestDist = Infinity;
      slides.forEach(function(s, i) {
        var d = Math.abs(leftOf(i) - track.scrollLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function swallowClick(ev) { ev.preventDefault(); ev.stopPropagation(); }

    track.addEventListener('pointerdown', function(e) {
      if (e.pointerType !== 'mouse' && e.pointerType !== 'pen') return;
      if (e.button !== 0 || (e.target.closest && e.target.closest('button, a'))) return;
      drag = { id: e.pointerId, x: e.clientX, left: track.scrollLeft, from: nearest(), moved: 0 };
      track.classList.add('is-dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
      e.preventDefault();
    });

    track.addEventListener('pointermove', function(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      drag.moved = Math.max(drag.moved, Math.abs(dx));
      track.scrollLeft = drag.left - dx;
    });

    function end(e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var moved = drag.moved;
      var idx = nearest();
      if (idx === drag.from && Math.abs(dx) > 40) {
        idx = Math.max(0, Math.min(slides.length - 1, idx + (dx < 0 ? 1 : -1)));
      }
      drag = null;
      try { track.releasePointerCapture(e.pointerId); } catch (err) {}
      track.classList.remove('is-dragging');
      track.scrollTo({ left: leftOf(idx), behavior: 'smooth' });
      if (moved > 6) {
        track.addEventListener('click', swallowClick, true);
        setTimeout(function() { track.removeEventListener('click', swallowClick, true); }, 0);
      }
    }
    track.addEventListener('pointerup', end);
    track.addEventListener('pointercancel', end);
    track.addEventListener('dragstart', function(e) { e.preventDefault(); });
  }

  function init() {
    initHeroCarousel();
    initPriceUpdate();
    initTitleRelocator();
    initGalleryTracking();
    initMouseDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-pads"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* LEGACY 2026-09-15 bundle-first rule, superseded by the pads rule of 2026-09-24
     (every filled slot, no bundle). Kept commented out, do not delete until every
     product has migrated and Marcus has hidden the bundle products.
  var NO_BUNDLE_PAD_RULE = 'first';

  function padLinesForNoBundle(singles) {
    return NO_BUNDLE_PAD_RULE === 'first' ? singles.slice(0, 1) : singles.slice();
  }
  */

  var DATA = {};
  try {
    var dataEl = document.getElementById('mayas-v3-pads-data');
    if (dataEl) DATA = JSON.parse(dataEl.textContent || '{}');
  } catch (e) { DATA = {}; }

  function apply(variantId) {
    var slots = DATA[String(variantId)] || { bundle: null, singles: [] };
    var singles = (slots.singles || []).filter(Boolean);
    var count = singles.length;

    /* LEGACY: window.__mayasV3PadItems = slots.bundle ? [slots.bundle] : padLinesForNoBundle(singles); */
    window.__mayasV3PadItems = singles.map(String);

    var line = document.getElementById('mayas-v3-pads-line');
    var text = document.getElementById('mayas-v3-pads-text');
    if (line && text) {
      if (count === 0) {
        line.hidden = true;
      } else {
        text.textContent = count === 1
          ? (line.getAttribute('data-label-one') || '')
          : (line.getAttribute('data-label-many') || '').replace('__N__', count);
        line.hidden = false;
      }
    }

    document.dispatchEvent(new CustomEvent('mayas-v3:pad-change', {
      bubbles: true,
      detail: { count: count, items: window.__mayasV3PadItems.slice() }
    }));
  }

  function init() {
    window.__mayasV3PadItems = [];
    if (!document.getElementById('mayas-v3-pads')) return;
    var input = document.getElementById('mayas-v3-variant-id');
    if (input && input.value) apply(input.value);
    document.addEventListener('mayas-v3:variant-change', function(e) {
      var v = e.detail && e.detail.variant;
      if (v && v.id) apply(v.id);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-perf"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  function initPerfSlider(slider) {
    var clip    = slider.querySelector('[data-perf-clip]');
    var divider = slider.querySelector('[data-perf-divider]');
    if (!clip || !divider) return;

    var pos = 50;
    var dragging = false;

    function setPos(percent) {
      percent = Math.max(0, Math.min(100, percent));
      pos = percent;
      slider.style.setProperty('--perf-pos', percent + '%');
    }

    function pointerToPercent(clientX) {
      var rect = slider.getBoundingClientRect();
      var x = clientX - rect.left;
      return (x / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      divider.setPointerCapture && e.pointerId && divider.setPointerCapture(e.pointerId);
      setPos(pointerToPercent(e.clientX));
      e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      setPos(pointerToPercent(e.clientX));
    }

    function onUp() {
      dragging = false;
    }

    divider.addEventListener('pointerdown', onDown);
    divider.addEventListener('pointermove', onMove);
    divider.addEventListener('pointerup', onUp);
    divider.addEventListener('pointercancel', onUp);
    divider.addEventListener('click', function(e) { e.preventDefault(); });
  }

  function initPerfCarousel(carousel) {
    var rail = carousel.querySelector('[data-perf-rail]');
    var prev = carousel.querySelector('[data-perf-prev]');
    var next = carousel.querySelector('[data-perf-next]');
    if (!rail || !prev || !next) return;

    function step() {
      var card = rail.querySelector('.mayas-v3-perf-card');
      if (!card) return rail.clientWidth * 0.8;
      var styles = getComputedStyle(rail);
      var gap = parseFloat(styles.columnGap || styles.gap || '16') || 16;
      return card.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= max;
    }

    prev.addEventListener('click', function() {
      rail.scrollBy({ left: -step(), behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      rail.scrollBy({ left: step(), behavior: 'smooth' });
    });
    rail.addEventListener('scroll', function() {
      window.requestAnimationFrame(update);
    });
    window.addEventListener('resize', update);
    update();
  }

  function initAll() {
    Array.prototype.slice
      .call(document.querySelectorAll('[data-perf-slider]'))
      .forEach(initPerfSlider);
    Array.prototype.slice
      .call(document.querySelectorAll('.mayas-v3-perf__carousel'))
      .forEach(initPerfCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* 2026-09-22: no collapsible wrapper. Both tabs start UNSELECTED and no panel
     is open. Tapping a tab opens its panel (ink underline slides in); tapping
     the active tab again closes everything. Height animates via the wrapper. */
  function initTabs(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var ink = root.querySelector('.mayas-v3-tabs__ink');
    var panelsWrap = root.querySelector('.mayas-v3-tabs__panels');
    if (!tabs.length || !panelsWrap) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var timer = 0;

    function moveInk(tab) {
      if (!ink) return;
      if (!tab) { ink.style.width = '0px'; return; }
      ink.style.width = tab.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + tab.offsetLeft + 'px)';
    }

    function settle() {
      clearTimeout(timer);
      root.classList.remove('is-animating');
      panelsWrap.style.height = '';
    }

    function animateHeight(from, to) {
      if (reduce) { settle(); return; }
      root.classList.add('is-animating');
      panelsWrap.style.height = from + 'px';
      void panelsWrap.offsetHeight;
      panelsWrap.style.height = to + 'px';
      clearTimeout(timer);
      timer = setTimeout(settle, 320);
    }

    function setState(active) {
      tabs.forEach(function(t) {
        var on = t === active;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        var panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) {
          if (on) { panel.removeAttribute('data-inactive'); } else { panel.setAttribute('data-inactive', ''); }
        }
      });
      moveInk(active);
    }

    function toggle(tab) {
      var from = panelsWrap.getBoundingClientRect().height;
      var closing = tab.getAttribute('aria-selected') === 'true';
      setState(closing ? null : tab);
      root.classList.toggle('has-active', !closing);
      var to = closing ? 0 : panelsWrap.scrollHeight;
      animateHeight(from, to);
    }

    tabs.forEach(function(tab, i) {
      tab.addEventListener('click', function() { toggle(tab); });
      tab.addEventListener('keydown', function(e) {
        var target = null;
        if (e.key === 'ArrowRight') target = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') target = tabs[(i - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home') target = tabs[0];
        if (e.key === 'End') target = tabs[tabs.length - 1];
        if (target) { e.preventDefault(); target.focus(); }
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(tab); }
      });
    });

    panelsWrap.addEventListener('transitionend', function(e) {
      if (e.target === panelsWrap && e.propertyName === 'height') settle();
    });
    window.addEventListener('resize', function() {
      moveInk(tabs.filter(function(t) { return t.getAttribute('aria-selected') === 'true'; })[0] || null);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.mayas-v3-tabs').forEach(initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mayas-v3-pdp-variants"] && !Shopify.designMode) return;
  try {
    
(function() {
  'use strict';

  /* B6 (2026-09-24): PostHog events via window.themeTrack (snippets/theme-track).
     Tracking never changes anything visible and never throws. */
  function track(name, props) {
    if (typeof window.themeTrack !== 'function') return;
    var ctx = document.getElementById('mayas-v3-track-ctx');
    var p = props || {};
    if (ctx) {
      p.product_id = Number(ctx.getAttribute('data-product-id')) || ctx.getAttribute('data-product-id');
      p.product_handle = ctx.getAttribute('data-product-handle') || '';
    }
    try { window.themeTrack(name, p); } catch (e) {}
  }

  /* How the next size selection happened: '' = shopper tap, 'wair' = Wair auto-select. */
  var nextVia = '';

  function initSizeGrid() {
    var grid = document.getElementById('mayas-v3-size-grid');
    if (!grid) return;
    var btns = Array.prototype.slice.call(grid.querySelectorAll('.mayas-v3-size'));
    if (!btns.length) return;
    var prompt = document.getElementById('mayas-v3-size-prompt');

    function select(btn, forcedVia) {
      var via = forcedVia || nextVia || 'tap';
      nextVia = '';
      var variantId    = btn.getAttribute('data-variant-id');
      var variantPrice = parseInt(btn.getAttribute('data-variant-price'), 10);
      var priceStr     = btn.getAttribute('data-variant-price-formatted') || '';
      var available    = btn.getAttribute('data-variant-available') !== 'false';
      var inventory    = parseInt(btn.getAttribute('data-variant-inventory'), 10) || 0;
      var state        = btn.getAttribute('data-variant-state') || 'in';
      var title        = btn.getAttribute('data-variant-title') || '';
      var preorderEta  = btn.getAttribute('data-preorder-eta') || '';
      var oosDate      = btn.getAttribute('data-oos-date') || '';

      btns.forEach(function(b) {
        b.classList.remove('mayas-v3-size--active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('mayas-v3-size--active');
      btn.setAttribute('aria-pressed', 'true');

      document.dispatchEvent(new CustomEvent('mayas-v3:variant-change', {
        bubbles: true,
        detail: {
          variantId: variantId,
          variant: {
            id: variantId,
            price: variantPrice,
            price_formatted: priceStr,
            available: available,
            inventory_quantity: inventory,
            state: state,
            title: title
          }
        }
      }));

      updateStockBar({ available: available, inventory_quantity: inventory, state: state, title: title, preorderEta: preorderEta, oosDate: oosDate });

      grid.setAttribute('data-select-via', via);
      grid.classList.remove('is-prompt');
      if (prompt) prompt.hidden = true;
      updateAlts(state, title);

      if (via !== 'url' && window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }

      track('size_selected', {
        size: title,
        stock_state: state,
        variant_id: Number(variantId),
        via: via
      });
    }

    /* B3: add to cart tapped with no size -> bring the sizes into view, red helper line. */
    document.addEventListener('mayas-v3:size-prompt', function(e) {
      var button = (e.detail && e.detail.button) || 'main';
      grid.classList.add('is-prompt');
      if (prompt) prompt.hidden = false;
      try {
        grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } catch (err) {
        grid.scrollIntoView();
      }
      track('size_prompt_shown', { button: button });
    });

    /* A size already active on load came from ?variant= in the URL. */
    var ctx = document.getElementById('mayas-v3-track-ctx');
    var initial = grid.querySelector('.mayas-v3-size--active');
    if (initial && ctx && ctx.getAttribute('data-initial-via') === 'url') {
      select(initial, 'url');
    } else if (initial) {
      grid.setAttribute('data-select-via', 'default');
    }

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() { select(btn); });
      btn.addEventListener('keydown', function(e) {
        var i = btns.indexOf(btn);
        var next = null;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = btns[(i + 1) % btns.length];
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = btns[(i - 1 + btns.length) % btns.length];
        if (next) { e.preventDefault(); next.focus(); select(next); }
      });
    });
  }

  function updateStockBar(variant) {
    var bar    = document.getElementById('mayas-v3-stock-bar');
    var fill   = document.getElementById('mayas-v3-stock-fill');
    var status = bar ? bar.querySelector('.mayas-v3-stock-bar__status') : null;
    var state = variant.state || 'in';
    if (!bar || !fill || !status) return;
    var pct;
    var label;
    switch (state) {
      case 'remote':
        pct = 100;
        label = bar.getAttribute('data-label-remote') || '';
        break;
      case 'preorder':
        pct = 100;
        label = bar.getAttribute('data-label-preorder') || '';
        break;
      case 'out':
        pct = 0;
        label = bar.getAttribute('data-label-out') || '';
        break;
      case 'low':
        var n = variant.inventory_quantity || 0;
        pct = n * 20;
        label = (bar.getAttribute('data-label-low-template') || '').replace('__N__', n);
        break;
      default:
        pct = 76;
        label = bar.getAttribute('data-label-ready') || '';
    }

    bar.className = 'mayas-v3-stock-bar mayas-v3-stock-bar--' + state;
    fill.style.width = pct + '%';
    status.textContent = label;

    var sizeLabel = document.getElementById('mayas-v3-stock-size');
    if (sizeLabel && variant.title) {
      var sizeTmpl = bar.getAttribute('data-label-size-template') || '';
      sizeLabel.textContent = sizeTmpl ? sizeTmpl.replace('__S__', variant.title) : variant.title;
    }

    var etaEl = document.getElementById('mayas-v3-preorder-eta');
    if (etaEl) {
      if (variant.preorderEta) {
        var tmpl = bar.getAttribute('data-label-preorder-ships-template') || '';
        etaEl.textContent = tmpl.replace('__D__', variant.preorderEta);
      } else {
        etaEl.textContent = bar.getAttribute('data-label-preorder-eta') || '';
      }
    }

    // Q37(a): back-in-stock line. data-oos-date is already future-guarded in Liquid,
    // so an empty value means "no usable date" and we fall back to the generic copy.
    var oosEl = document.getElementById('mayas-v3-oos-eta');
    if (oosEl) {
      oosEl.textContent = '';
      if (variant.oosDate) {
        oosEl.textContent = (bar.getAttribute('data-label-oos-date-template') || '').replace('__D__', variant.oosDate);
      } else {
        oosEl.textContent = bar.getAttribute('data-label-oos-default') || '';
      }
    }
  }

  /* B3: on a sold-out size, show up to 3 candidates that are in stock in that size
     (in/low first, then remote), each linking straight to that size. */
  function updateAlts(state, size) {
    var root = document.getElementById('mayas-v3-alts');
    if (!root) return;
    var row = root.querySelector('.mayas-v3-alts__row');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.mayas-v3-alt'));
    cards.forEach(function(c) { c.hidden = true; c.removeAttribute('data-slot'); });
    if (state !== 'out' || !row) { root.hidden = true; return; }
    var key = String(size || '').trim().toUpperCase();
    var inStock = [];
    var remote = [];
    cards.forEach(function(c) {
      var map = {};
      try { map = JSON.parse(c.getAttribute('data-sizes') || '{}'); } catch (e) { map = {}; }
      var entry = map[key];
      if (!entry) return;
      if (entry[0] === 'in' || entry[0] === 'low') inStock.push([c, entry[1]]);
      else if (entry[0] === 'remote') remote.push([c, entry[1]]);
    });
    var pick = inStock.concat(remote).slice(0, 3);
    if (!pick.length) { root.hidden = true; return; }
    var tmpl = root.getAttribute('data-in-size-template') || '';
    pick.forEach(function(p, i) {
      var c = p[0];
      var base = (c.getAttribute('href') || '').split('?')[0];
      c.setAttribute('href', base + '?variant=' + p[1]);
      c.setAttribute('data-slot', String(i + 1));
      var stock = c.querySelector('[data-alt-stock]');
      if (stock) stock.textContent = tmpl.replace('__S__', size);
      row.appendChild(c);
      c.hidden = false;
    });
    root.hidden = false;
  }

  function initAlts() {
    var root = document.getElementById('mayas-v3-alts');
    if (!root) return;
    root.addEventListener('click', function(e) {
      var card = e.target.closest('.mayas-v3-alt');
      if (!card) return;
      track('instock_alternative_clicked', {
        from_product: root.getAttribute('data-from-product') || '',
        to_product: card.getAttribute('data-to-product') || '',
        slot: Number(card.getAttribute('data-slot')) || 0
      });
    });
  }

  /* B2: consent info icon next to the email field. Tap opens a short note; a second
     tap, a tap anywhere else or Escape closes it. */
  function setInfo(btn, open) {
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var note = document.getElementById(btn.getAttribute('aria-controls'));
    if (note) note.hidden = !open;
  }

  function initNotifyInfo() {
    document.addEventListener('click', function(e) {
      var info = e.target.closest('[data-notify-info]');
      Array.prototype.forEach.call(document.querySelectorAll('[data-notify-info][aria-expanded="true"]'), function(b) {
        if (b !== info) setInfo(b, false);
      });
      if (info) {
        e.preventDefault();
        setInfo(info, info.getAttribute('aria-expanded') !== 'true');
      }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(document.querySelectorAll('[data-notify-info][aria-expanded="true"]'), function(b) {
        setInfo(b, false);
      });
    });
  }

  /* B6: notify_subscribed / notify_subscribe_failed. Fired from the
     'mayas-notify:result' event the Klaviyo handler dispatches after the call ends, so
     notify_subscribed only counts accepted sign-ups. Contract (same for the desktop
     form): product_id, product_handle, product_title, colour, size, variant_id,
     stock_state, reason (sold_out / preorder), source ('pdp'); failures add error. */
  function initNotifyTracking() {
    var ctx = document.getElementById('mayas-v3-track-ctx');
    document.addEventListener('mayas-notify:result', function(e) {
      var d = e.detail || {};
      var props = {
        product_title: ctx ? (ctx.getAttribute('data-product-title') || '') : '',
        colour: ctx ? (ctx.getAttribute('data-colour') || null) : null,
        size: d.size || '',
        variant_id: Number(d.variant_id) || null,
        stock_state: d.stock_state || '',
        reason: d.reason || 'sold_out',
        source: 'pdp'
      };
      if (d.ok) {
        track('notify_subscribed', props);
      } else {
        props.error = d.error || 'unknown';
        track('notify_subscribe_failed', props);
      }
    });
  }

  function initFindSizeChip() {
    var chip = document.getElementById('mayas-v3-find-size-chip');
    if (!chip) return;
    chip.addEventListener('click', function(e) {
      e.preventDefault();
      /* Wair injects #wair-fit-advisor (origin-gated: may never appear on
         theme-dev). Poll 4s, then fall back to the size-guide page. */
      var deadline = Date.now() + 4000;
      (function tryOpen() {
        var w = document.getElementById('wair-fit-advisor');
        if (w) { w.click(); return; }
        if (Date.now() < deadline) { window.requestAnimationFrame(tryOpen); return; }
        var href = chip.getAttribute('data-guide-url');
        if (href && href !== '#') window.location.href = href;
      })();
    });
    initWairRecMirror(chip);
  }

  /* Q40-42 (2026-09-23): once a shopper has a Wair profile, Wair rewrites its own
     (off-screen) button to "Din størrelse: <b>M</b>" with class .wair-rec-btn. Mirror
     that size into the chip, and preselect the size once per page view unless the
     shopper has already tapped a size themselves or that size is sold out. */
  function initWairRecMirror(chip) {
    var launcher = document.querySelector('.mayas-v3-wair-launcher');
    var grid = document.getElementById('mayas-v3-size-grid');
    var recEl = chip.querySelector('.mayas-v3-find-size-chip__rec');
    var sizeEl = chip.querySelector('.mayas-v3-find-size-chip__size');
    if (!launcher || !recEl || !sizeEl) return;
    var defaultAria = chip.getAttribute('aria-label') || '';
    var userPicked = false;
    var preselected = false;

    if (grid) {
      grid.addEventListener('click', function(e) {
        if (e.isTrusted && e.target.closest('.mayas-v3-size')) userPicked = true;
      });
    }

    function readWairSize() {
      var w = document.getElementById('wair-fit-advisor');
      if (!w || !w.classList.contains('wair-rec-btn')) return '';
      var b = w.querySelector('b');
      return b ? b.textContent.trim() : '';
    }

    function preselect(size) {
      if (preselected || userPicked || !grid) return;
      var want = size.toLowerCase();
      var btn = Array.prototype.slice.call(grid.querySelectorAll('.mayas-v3-size')).filter(function(b) {
        return (b.getAttribute('data-variant-title') || '').trim().toLowerCase() === want;
      })[0];
      if (!btn) return;
      preselected = true;
      if (btn.getAttribute('data-variant-state') === 'out') return;
      if (btn.getAttribute('aria-pressed') !== 'true') {
        nextVia = 'wair';
        btn.click();
        nextVia = '';
      }
    }

    function sync() {
      var size = readWairSize();
      if (size) {
        sizeEl.textContent = size;
        recEl.hidden = false;
        chip.classList.add('is-rec');
        chip.setAttribute('aria-label', (chip.getAttribute('data-rec-aria') || '').replace('__S__', size));
        preselect(size);
      } else {
        recEl.hidden = true;
        chip.classList.remove('is-rec');
        chip.setAttribute('aria-label', defaultAria);
      }
    }

    new MutationObserver(sync).observe(launcher, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
    sync();
  }

  /* Order-cutoff countdown in the in/low shipping row (moved from the retired
     mayas-v3-pdp-delivery section; same logic, updates every minute). */
  function initDeliveryEta() {
    var root = document.getElementById('mayas-v3-eta');
    if (!root) return;
    var cdEl   = document.getElementById('mayas-v3-eta-countdown');
    var dateEl = document.getElementById('mayas-v3-eta-date');
    if (!cdEl || !dateEl) return;

    var cutoffHour   = parseInt(root.getAttribute('data-cutoff-hour'), 10) || 14;
    var businessDays = parseInt(root.getAttribute('data-business-days'), 10) || 3;
    var cdFormat     = root.getAttribute('data-countdown-format') || '{h}h {m}m';
    var locale       = root.getAttribute('data-locale') || 'da';
    var dateLocale   = locale.indexOf('da') === 0 ? 'da-DK' : 'en-GB';

    function isWeekend(d) {
      var day = d.getDay();
      return day === 0 || day === 6;
    }
    function addBusinessDays(d, n) {
      var r = new Date(d.getTime());
      while (n > 0) {
        r.setDate(r.getDate() + 1);
        if (!isWeekend(r)) n--;
      }
      return r;
    }
    function nextBusinessDay(d) {
      var r = new Date(d.getTime());
      do { r.setDate(r.getDate() + 1); } while (isWeekend(r));
      return r;
    }
    function formatCountdown(ms) {
      if (ms < 0) ms = 0;
      var totalMin = Math.floor(ms / 60000);
      return cdFormat.replace('{h}', Math.floor(totalMin / 60)).replace('{m}', totalMin % 60);
    }
    function formatDate(d) {
      try {
        return d.toLocaleDateString(dateLocale, { weekday: 'long', day: 'numeric', month: 'long' });
      } catch (e) {
        return d.toISOString().slice(0, 10);
      }
    }
    function update() {
      var now = new Date();
      var todayCutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutoffHour, 0, 0, 0);
      var beforeCutoffWeekday = !isWeekend(now) && (now < todayCutoff);
      var dispatch, cutoff;
      if (beforeCutoffWeekday) {
        dispatch = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        cutoff = todayCutoff;
      } else {
        dispatch = nextBusinessDay(now);
        cutoff = new Date(dispatch.getFullYear(), dispatch.getMonth(), dispatch.getDate(), cutoffHour, 0, 0, 0);
      }
      cdEl.textContent = formatCountdown(cutoff.getTime() - now.getTime());
      dateEl.textContent = formatDate(addBusinessDays(dispatch, businessDays));
    }
    update();
    setInterval(update, 60 * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initSizeGrid();
      initFindSizeChip();
      initDeliveryEta();
      initAlts();
      initNotifyInfo();
      initNotifyTracking();
    });
  } else {
    initSizeGrid();
    initFindSizeChip();
    initDeliveryEta();
    initAlts();
    initNotifyInfo();
    initNotifyTracking();
  }
})();

/* Back-in-stock notify -> Klaviyo Back in Stock subscription (client API).
   Same contract as v2: direct POST to Klaviyo's public /client/ endpoint
   (company SgwkrS), pristine-iframe fetch fallback when third-party fetch
   wrappers hard-fail cross-origin POSTs. */
(function(){
  var COMPANY = 'SgwkrS';
  function pristineFetch(url, opts) {
    var ifr = document.createElement('iframe');
    ifr.style.display = 'none';
    document.body.appendChild(ifr);
    var f = ifr.contentWindow && ifr.contentWindow.fetch;
    if (!f) { ifr.remove(); return Promise.reject(new Error('no iframe fetch')); }
    return f.call(ifr.contentWindow, url, opts).finally(function(){ ifr.remove(); });
  }
  function bisFetch(url, opts) {
    return fetch(url, opts).catch(function(){ return pristineFetch(url, opts); });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-notify-btn]');
    if (!btn) return;
    var wrap = btn.closest('.mayas-v3-stock-bar__notify');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="email"]');
    var msg = wrap.querySelector('[data-notify-msg]');
    var email = input ? input.value.trim() : '';
    var active = document.querySelector('.mayas-v3-size--active[data-variant-id]') ||
                 document.querySelector('.mayas-v3-size[aria-pressed="true"]');
    var variantId = active ? active.getAttribute('data-variant-id') : '';
    function show(text, isError) {
      if (!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.toggle('is-error', !!isError);
    }
    if (!email || email.indexOf('@') < 1) { if (input) input.focus(); return; }
    if (!variantId) return;
    btn.disabled = true;
    /* 2026-09-24 (BIS audit, marketing/email/2026-09-24_Back_In_Stock_Flow_Audit.md):
       sold_out -> Klaviyo Back in Stock (unchanged payload) + a "Notify Requested"
       event that stores the shop language on the profile (storefront_locale) so the
       flow can split DA/EN. preorder -> ONLY the "Notify Requested" event: pre-order
       variants sell on CONTINUE, which Klaviyo Back in Stock never fires for; a
       server script mails them when the size is physically in stock.
       Neither call touches email-marketing consent or any list. */
    var reason = wrap.getAttribute('data-notify-reason') ||
                 (active && active.getAttribute('data-variant-state') === 'preorder' ? 'preorder' : 'sold_out');
    var loc = String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'da').slice(0, 2).toLowerCase();
    var CLIENT = 'https://a.klaviyo.com/client/';
    var HDRS = { 'Content-Type': 'application/json', revision: '2024-10-15' };
    var eventPayload = {
      data: {
        type: 'event',
        attributes: {
          metric: { data: { type: 'metric', attributes: { name: 'Notify Requested' } } },
          profile: { data: { type: 'profile', attributes: { email: email, properties: { storefront_locale: loc } } } },
          properties: {
            reason: reason,
            locale: loc,
            variant_id: variantId,
            product_handle: active ? (active.getAttribute('data-variant-handle') || '') : '',
            size: active ? (active.getAttribute('data-variant-title') || '') : '',
            ship_date_display: active ? (active.getAttribute('data-preorder-eta') || '') : ''
          }
        }
      }
    };
    function sendEvent() {
      return bisFetch(CLIENT + 'events/?company_id=' + encodeURIComponent(COMPANY), {
        method: 'POST', headers: HDRS, body: JSON.stringify(eventPayload)
      });
    }
    var payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          channels: ['EMAIL'],
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
      }
    };
    var request = reason === 'preorder' ? sendEvent() :
      bisFetch(CLIENT + 'back-in-stock-subscriptions/?company_id=' + encodeURIComponent(COMPANY), {
        method: 'POST', headers: HDRS, body: JSON.stringify(payload)
      }).then(function(r){
        if (r.status === 202 || r.ok) { sendEvent().catch(function(){}); }
        return r;
      });
    /* B6: tell tracking how the Klaviyo call ended (theme-events contract, see
       tracking/2026-09-24_Theme_Events.md). Tracking listens; nothing visible. */
    function result(ok, err) {
      try {
        wrap.dispatchEvent(new CustomEvent('mayas-notify:result', { bubbles: true, detail: {
          ok: ok, reason: reason, variant_id: variantId,
          size: active ? (active.getAttribute('data-variant-title') || '') : '',
          stock_state: active ? (active.getAttribute('data-variant-state') || '') : '',
          error: err ? String((err && err.message) || err) : ''
        } }));
      } catch (e) {}
    }
    request.then(function(r){
      if (r.status === 202 || r.ok) {
        if (input) input.value = '';
        show(wrap.getAttribute('data-msg-success') || 'OK', false);
        result(true);
      } else {
        return Promise.reject(new Error('BIS status ' + r.status));
      }
    }).catch(function(err){
      btn.disabled = false;
      show(wrap.getAttribute('data-msg-error') || 'Error', true);
      console.warn('[mayas-v3] Klaviyo BIS subscribe failed', err);
      result(false, err);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
